<template>
  <div class="model-type-card">
    <v-container fluid style="padding: 12px">
      <div style="display: flex; align-items: center; margin-top: -20px">
          <div class="model-header-title-group">
          <img v-if="!localEditAction" src="@/assets/ic_round-plus-black.svg" alt="img" width="24" height="24" />
          <label style="font-size: 24px; font-weight: 600">
            {{ page == 'view model' ? 'View Model' : localEditAction != null ? (localEditAction ? 'Update Model' : 'Create Model') : 'Create Model' }}
          </label>
        </div>
          <v-chip v-if="LLmsModel.modelDisplay" id="modelID-modelmanagement" class="model-id-chip" variant="flat" pill>
            <span class="model-id-chip__text">Model ID: {{ LLmsModel.modelDisplay }}</span>
          </v-chip>

          <v-menu v-model="categoryMenuOpen" :close-on-content-click="false" offset="6" location="bottom start">
            <template v-slot:activator="{ props }">
              <v-btn id="category-menu-trigger-modelmanagement" v-bind="props" variant="text" size="small" class="category-menu-trigger">
                <v-icon size="18" :color="LLmsModel.categoryName ? '#1976D2' : '#94a3b8'" class="me-1">mdi-tag-outline</v-icon>
                <span class="category-menu-text" :class="{ 'category-menu-text--placeholder': !LLmsModel.categoryName }">
                  {{ LLmsModel.categoryName || 'Category' }}
                </span>
                <v-icon size="16" color="#94a3b8" class="ms-1">mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list density="compact" class="category-menu-list" :max-height="320">
              <v-list-item @click.stop="openAddCategoryDialog" class="category-menu-new">
                <template #prepend>
                  <v-icon color="primary" size="18">mdi-tag-plus-outline</v-icon>
                </template>
                <v-list-item-title class="category-menu-new__title">New Category</v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item v-if="LLmsModel.categoryName" @click="selectCategoryFromHeader(null)">
                <template #prepend>
                  <v-icon size="18" color="#94a3b8">mdi-close-circle-outline</v-icon>
                </template>
                <v-list-item-title>Clear category</v-list-item-title>
              </v-list-item>
              <v-divider v-if="LLmsModel.categoryName" />
              <v-list-item v-if="categoryOptions.length === 0">
                <v-list-item-title class="category-menu-empty">No categories yet</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-for="item in categoryOptions"
                :key="item.name"
                :active="LLmsModel.categoryName === item.name"
                @click="selectCategoryFromHeader(item.name)"
              >
                <template #prepend>
                  <v-icon size="15" color="#1976D2">mdi-tag-outline</v-icon>
                </template>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        <div class="publication-header-wrapper">
          <div class="publication-header-controls">
            <v-chip class="publication-status-chip" :color="LLmsModel.isPublish ? '#2ABF56' : '#C1C3CB'" variant="elevated" size="45" pill>
              <span class="text-capitalize" style="color: #ffffff !important">
                {{ LLmsModel.isPublish ? 'Published' : 'Draft' }}
              </span>
            </v-chip>

            <span class="publication-label">Publication Control</span>

            <v-switch id="publication-header-switch" class="memory-switch mt-6" v-model="LLmsModel.isPublish" />

            <span class="publication-version text-capitalize">Version {{ LLmsModel.versioning || '1' }}</span>
          </div>
        </div>
      </div>
      <div style="margin-top: -12px">
        <hr />
      </div>
      <v-form class="mt-6" ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-row>
              <v-container fluid>
                <v-row>
                  <!-- Model Type & Name Card -->
                  <v-col cols="12">
                    <v-row class="model-input-group" align="start">
                      <v-col cols="8">
                        <v-row align="start">
                          <!-- Model Name -->
                          <v-col cols="6" class="model-input-col">
                            <span>Model Name <span style="color: red">*</span> </span>
                            <v-text-field
                              id="modelname-field-modelmanagement"
                              v-model="LLmsModel.modelName"
                              :rules="[rules.required]"
                              required
                              density="compact"
                              variant="none"
                              placeholder="Model Name"
                              persistent-hint
                              class="model-input-control"
                            >
                            </v-text-field>
                          </v-col>

                          <!-- Model -->
                          <v-col cols="6" class="model-input-col">
                            <span>Model <span style="color: red">*</span> </span>
                            <v-autocomplete
                              id="model-autocomplete-modelmanagement"
                              v-model="LLmsModel.model"
                              :items="modelSelectionOptions"
                              item-title="modelDisplay"
                              item-value="modelName"
                              :rules="modelSelectionRules"
                              :no-data-text="modelNoDataText"
                              required
                              density="compact"
                              variant="none"
                              placeholder="Model"
                              @update:model-value="handleModelChange"
                              persistent-hint
                              clearable
                              class="model-input-control"
                            >
                              <template v-slot:item="{ props, item, index }">
                                <v-list-item placeholder="Model" v-bind="props" :id="'model-gptmodeldetail-option-' + index" :value="item.raw.modelName" :title="getModelSelectionDisplay(item.raw)">
                                  <template v-slot:subtitle>
                                    <div class="model-option-subtitle">
                                      <span class="model-option-meta">
                                        <span class="model-option-meta-value">{{ item.raw.platform || '-' }}</span>
                                      </span>
                                      <span class="model-option-meta-separator">/</span>
                                      <span class="model-option-meta">
                                        <span class="model-option-meta-value">{{ item.raw.provider || '-' }}</span>
                                      </span>
                                    </div>
                                  </template>
                                </v-list-item>
                              </template>
                              <template v-slot:selection="{ item }">
                                <span class="model-selection-title">{{ getModelSelectionDisplay(item.raw) }}</span>
                              </template>
                            </v-autocomplete>
                            <div v-if="selectedModelInfo" class="model-provider-details">
                              <span class="model-provider-pill">
                                <v-icon icon="mdi-server-network" size="14" color="primary" class="me-1"></v-icon>
                                <span class="model-provider-label">Platform</span>
                                <span class="model-provider-value">{{ selectedModelInfo.platform || '-' }}</span>
                              </span>
                              <span class="model-provider-pill">
                                <v-icon icon="mdi-cloud-outline" size="14" color="primary" class="me-1"></v-icon>
                                <span class="model-provider-label">Provider</span>
                                <span class="model-provider-value">{{ selectedModelInfo.provider || '-' }}</span>
                              </span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>

                      <!-- Model Type and model name-->
                      <v-col cols="4">
                        <v-row>
                          <div class="flexAllCenter mx-8">
                            <div class="custom-vertical-divider"></div>
                          </div>
                          <!-- Model Type -->
                          <div style="display: flex; flex-direction: column; justify-content: flex-start !important; width: 80%">
                            <span>Model Type <span style="color: red">*</span> </span>
                            <div class="model-type-toggle-container">
                              <v-btn-toggle v-model="LLmsModel.typeLLM" class="model-type-toggle" density="compact">
                                <v-btn id="button-bot-modelmanagement" :value="0" class="model-type-btn" :disabled="localEditAction"><span style="font-weight: 600; font-size: 16px">Bot</span></v-btn>
                                <v-btn id="button-guardrail-modelmanagement" :value="1" class="model-type-btn" :disabled="localEditAction"
                                  ><span style="font-weight: 600; font-size: 16px">Guard Rail</span></v-btn
                                >
                              </v-btn-toggle>
                            </div>
                          </div>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- Description - Full Width -->
                      <v-col cols="12" class="mt-3" style="display: flex; flex-direction: column">
                        <span>Description</span>
                        <v-textarea
                          id="description-textarea-modelmanagement"
                          v-model="LLmsModel.description"
                          density="compact"
                          variant="none"
                          auto-grow
                          rows="1"
                          placeholder="Brief description of what this model does"
                          persistent-hint
                          class="description-field"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <transition name="fade">
                        <div v-if="txtToImgChecker" class="image-settings-container mb-4" style="width: 100%">
                          <!-- Enhanced Header -->
                          <v-card class="image-settings-card">
                            <v-card-title>
                              <div class="d-flex align-center justify-start gap-2">
                                <img src="@/assets/mynaui_image-solid.svg" alt="img" width="24" height="24" class="mr-3" />
                                <h3 style="font-weight: 700; color: #171717">Image Generation Settings</h3>
                              </div>
                              <span style="color: #646464; font-size: 16px">Configure AI image generation parameters</span>
                            </v-card-title>

                            <div class="pa-4">
                              <hr />
                            </div>

                            <!-- Enhanced Content -->
                            <v-card-text class="pa-6">
                              <v-row class="image-settings-row">
                                <!-- Style Selection -->
                                <v-col cols="12" sm="12" md="4">
                                  <div class="label-style">
                                    <img src="@/assets/fluent_style-guide-24-regular.svg" alt="img" width="18" height="18" />
                                    <label for="Image Style" style="color: #171717; font-size: 16px">Image Style</label>
                                    <span style="color: red; margin-left: 4px">*</span>
                                    <v-tooltip location="top" max-width="230px">
                                      <template v-slot:activator="{ props }">
                                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                                      </template>
                                      <span>The artistic filter or look applied to the generated image.</span>
                                    </v-tooltip>
                                  </div>

                                  <v-select
                                    id="imagestyle-select-modelmanagement"
                                    v-model="LLmsModel.styleImage"
                                    :items="imageStyleOptions"
                                    item-title="text"
                                    item-value="value"
                                    :rules="[rules.required]"
                                    variant="none"
                                    density="compact"
                                    required
                                    class="model-input-control"
                                    style="margin-top: -3px"
                                    placeholder="Choose image style"
                                  >
                                    <template v-slot:selection="{ item }">
                                      <div class="d-flex align-center">
                                        <!-- <v-icon :color="item.raw.value === 'natural' ? 'green' : 'orange'" size="small"
                                          class="mr-2">
                                          {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                        </v-icon> -->
                                        <span class="font-weight-medium">{{ item.raw.text }}</span>
                                      </div>
                                    </template>

                                    <template v-slot:item="{ props, item }">
                                      <v-list-item v-bind="props" class="style-item">
                                        <template v-slot:prepend>
                                          <v-avatar :color="item.raw.value === 'natural' ? 'green lighten-4' : 'orange lighten-4'" size="32">
                                            <v-icon size="16" color="white">
                                              {{ item.raw.value === 'natural' ? 'mdi-leaf' : 'mdi-creation' }}
                                            </v-icon>
                                          </v-avatar>
                                        </template>
                                        <template v-slot:title>
                                          <span class="font-weight-medium">{{ item.raw.text }}</span>
                                        </template>
                                        <template v-slot:subtitle>
                                          <span class="text-caption">
                                            {{ item.raw.value === 'natural' ? 'Realistic and natural looking' : 'Vibrant and dramatic style' }}
                                          </span>
                                        </template>
                                      </v-list-item>
                                    </template>
                                  </v-select>

                                  <!-- <div>
                                    <v-icon size="small" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                    <span class="text-caption text-grey-darken-1">Choose the artistic style for generated
                                      images</span>
                                  </div> -->
                                </v-col>

                                <!-- Quality Setting -->
                                <v-col cols="12" sm="12" md="4">
                                  <div class="label-style">
                                    <img src="@/assets/mdi_quality-high.svg" alt="img" width="18" height="18" />
                                    <label for="Image Quality">Image Quality</label>
                                  </div>

                                  <v-autocomplete placeholder="Quality Level" variant="none" density="compact" disabled v-model="LLmsModel.quality" class="model-input-control" readonly>
                                  </v-autocomplete>
                                </v-col>

                                <!-- Resolution Setting -->
                                <v-col cols="12" sm="12" md="4">
                                  <div class="label-style">
                                    <img src="@/assets/eva_monitor-outline.svg" alt="img" width="18" height="18" />
                                    <label for="Image Resolution">Image Resolution</label>
                                    <v-tooltip location="top" max-width="230px">
                                      <template v-slot:activator="{ props }">
                                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="info" width="18" height="18" style="cursor: pointer; margin-left: 4px" />
                                      </template>
                                      <span>Set the output image size and quality, defined by the total pixel dimensions</span>
                                    </v-tooltip>
                                  </div>

                                  <v-autocomplete label="Image Size" variant="none" density="compact" disabled v-model="LLmsModel.resolution" value="1024x1024" class="model-input-control" readonly>
                                  </v-autocomplete>

                                  <!-- <div>
                                    <v-icon size="small" color="grey-darken-1" class="mr-1">mdi-information-outline</v-icon>
                                    <span class="text-caption text-grey-darken-1">Image resolution in pixels</span>
                                  </div> -->
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </div>
                      </transition>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="8">
                    <!-- Header with info and action buttons -->
                    <div style="display: flex; align-items: center; gap: 12px">
                      <img src="@/assets/lucide_pen-line.svg" alt="img" width="20" height="20" />
                      <span style="font-weight: 600; color: #171717; font-size: 16px">Set System Prompt for Your Model</span>
                    </div>
                    <v-card variant="none" class="prompt-editor-card">
                      <v-card-text class="">
                        <v-textarea
                          id="PromptTemplate"
                          :label="''"
                          variant="plain"
                          counter
                          auto-grow
                          rows="8"
                          v-model="LLmsModel.promptTemplate"
                          :rules="[validatePrompt(LLmsModel.promptTemplate)]"
                          required
                          placeholder="Enter your system prompt here..."
                          class="prompt-textarea"
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <v-col cols="4">
                    <v-card class="prompt-templates-card h-100">
                      <v-card-title class="py-3 px-4 d-flex align-center">
                        <span class="text-subtitle-2" style="font-weight: 700; color: #171717; font-size: 14px">Prompt Template</span>
                        <div class="d-flex align-center ml-2">
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="20" height="20" />
                            </template>
                            <span>Select a prompt template to replace the current prompt.</span>
                          </v-tooltip>
                        </div>
                      </v-card-title>

                      <div class="px-3 pt-3">
                        <v-autocomplete
                          class="select-prompt mb-3 rounded-input padding-input"
                          id="groupprompttemplate-autocomplete-modelmanagement"
                          :items="DDGroupPromptTemplate"
                          item-title="name"
                          placeholder="Select Prompt Template"
                          item-value="id"
                          density="compact"
                          clearable
                          variant="none"
                          v-model="groupPromptTemplate"
                          hide-details
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'groupprompttemplate-gptmodeldetail-option-' + index" :value="item.raw.name">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>

                      <!-- <v-divider class="mt-2"></v-divider> -->

                      <v-list class="prompt-template-list" density="compact">
                        <div v-if="filteredPromptTemplates.length === 0" class="pa-4 text-center text-grey-darken-1 h-100 mt-9">
                          <Icon class="d-block mx-auto mb-2" icon="fluent:book-template-20-filled" style="font-size: 22px; color: #8d8d8d" />
                          <span>No templates available</span>
                        </div>

                        <template v-else>
                          <v-list-item v-for="(item, i) in filteredPromptTemplates.slice(0, 10)" :key="i" @click="SetSelectPromptTemplate(item)" :ripple="true" class="template-list-item">
                            <template v-slot:prepend>
                              <v-icon icon="mdi-text-box-outline" size="small"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span id="list-nameprompttemplate-modelmanagement" class="text-body-2">{{ item.name }}</span>
                            </template>
                            <template v-slot:append>
                              <v-icon size="small" color="primary">mdi-plus-circle-outline</v-icon>
                            </template>
                          </v-list-item>

                          <div v-if="filteredPromptTemplates.length > 10" class="d-flex justify-center py-2">
                            <v-btn
                              id="button-showallprompttemplate-modelmanagement"
                              variant="text"
                              color="primary"
                              size="small"
                              density="comfortable"
                              @click="showAll"
                              prepend-icon="mdi-format-list-bulleted"
                            >
                              {{ $t('_ShowAll') }} ({{ filteredPromptTemplates.length }})
                            </v-btn>
                          </div>
                        </template>
                      </v-list>
                    </v-card>
                    <!-- Context menu for prompt templates -->
                    <v-menu v-model="showMenu" :activator="{ x, y }" location="bottom">
                      <v-card min-width="250" elevation="3">
                        <v-list density="compact" class="py-0">
                          <v-list-subheader class="d-flex bg-grey-lighten-4 py-2">
                            <v-icon icon="mdi-text-box-plus-outline" class="me-2" size="small"></v-icon>
                            Insert Template
                          </v-list-subheader>
                          <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                          <v-list-item
                            v-for="(item, index) in filteredPromptTemplates"
                            :key="index"
                            @click="
                              SetSelectPromptTemplate(item);
                              showMenu = false;
                            "
                            :value="item.name"
                            class="template-list-item"
                          >
                            <template v-slot:prepend>
                              <v-icon size="small" icon="mdi-text-box-outline"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span>{{ item.name }}</span>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </v-col>

                  <!-- Dialog for showing all templates -->
                  <v-dialog v-model="dialogShowAll" max-width="550" scrollable>
                    <v-card>
                      <v-card-title class="bg-primary text-white d-flex align-center">
                        <v-icon icon="mdi-text-box-multiple-outline" class="me-2"></v-icon>
                        Prompt Templates
                      </v-card-title>
                      <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      <v-card-text style="max-height: 500px" class="pt-4">
                        <v-text-field
                          v-model="templateSearchQuery"
                          label="Search templates"
                          prepend-inner-icon="mdi-magnify"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="mb-3"
                          clearable
                        ></v-text-field>

                        <v-list density="compact" class="template-list-all pa-0">
                          <v-list-item v-for="(item, i) in searchedTemplates" :key="i" @click="SetSelectPromptTemplate(item)" class="template-list-item" :ripple="true">
                            <template v-slot:prepend>
                              <v-icon size="small" color="primary" icon="mdi-text-box-outline"></v-icon>
                            </template>
                            <template v-slot:title>
                              <span :id="'list-nameprompttemplateall-modelmanagement-' + i">{{ item.name }}</span>
                            </template>
                            <template v-slot:subtitle>
                              <span class="text-caption text-truncate">{{ truncatePrompt(item.prompt) }}</span>
                            </template>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                      <v-divider :thickness="1" class="border-opacity-100"></v-divider>
                      <v-card-actions class="pa-3 bg-grey-lighten-4">
                        <v-spacer></v-spacer>
                        <v-btn id="button-close-popupshowall-modelmanagement" color="primary" variant="text" @click="dialogShowAll = false">
                          {{ $t('close') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>

                <!-- Extension Configuration -->
                <!-- <v-card class="mb-1" variant="outlined">
                  <v-row style="margin: 10px 0px" no-gutters>
                    <v-col sm="2" class="d-flex align-center font-weight-bold" style="white-space: nowrap">
                      Model Configuration
                    </v-col>
                    <v-col sm="10" class="d-flex align-center">
                      <v-divider :thickness="1" class="border-opacity-90"></v-divider>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-row density="compact">

                      <v-col cols="12" md="4">
                        <v-text-field id="model-extension-modelmanagement" v-model="LLmsModel.extension"
                          label="Extension" density="compact" variant="outlined" prepend-inner-icon="mdi-puzzle-outline"
                          hint="Optional model extension" persistent-hint></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card> -->
              </v-container>
            </v-row>

            <!-- Knowledge -->
            <v-card class="knowledge-card mt-4">
              <h3 style="color: #c32e0e; font-weight: 600">Knowledge</h3>
              <div class="d-flex align-center justify-start mt-2 mb-2" style="gap: 8px">
                <img src="@/assets/f7_doc-text-fill.svg" alt="img" width="20" height="20" />
                <span style="font-weight: 600; font-size: 16px; color: #171717">Documents</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">Document Name</span>
                  <v-autocomplete
                    class="model-input-control mt-2"
                    id="documentname-autocomplete-modelmanagement"
                    :placeholder="'Document Name'"
                    clearable
                    :items="DDVector"
                    item-title="name"
                    item-value="name"
                    density="compact"
                    chips
                    deletable-chips
                    multiple
                    variant="none"
                    v-model="LLmsModel.vectordbName"
                    :rules="[rules.required]"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'documentname-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon id="infovectorDBname-modelmanagement" size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoVectorDBName') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <!-- <span class="mt-2" style="font-size: 14px; color: #171717;">Text Replacement</span> -->
                  <v-autocomplete
                    class="model-input-control mt-8"
                    id="text-replacement-modelmanagement"
                    :placeholder="'Text Replacement'"
                    clearable
                    :items="DDGroupReplace"
                    item-title="name"
                    density="compact"
                    chips
                    deletable-chips
                    item-value="id"
                    multiple
                    variant="none"
                    v-model="LLmsModel.groupReplaceID"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'textreplacement-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon id="InfoGroupReplaceText-modelmanegement" text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoGroupReplaceText') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">Top-N Chunk</span>
                  <v-text-field
                    class="model-input-control mt-2"
                    id="top-n-chunks-field-modelmanagement"
                    :placeholder="'Top-N Chunks'"
                    density="compact"
                    :disabled="LLmsModel.vectordbName.length == 0"
                    v-model="LLmsModel.topVDB"
                    variant="none"
                    @keypress="isNumberpositive($event)"
                    :rules="[checkValidate()]"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon id="infotopVDB-modelmanagement" text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoTopVDB') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>

              <!-- Database -->
              <div class="d-flex align-center justify-start mb-2 mt-4" style="gap: 8px">
                <img src="@/assets/solar_database-bold.svg" alt="img" width="20" height="20" />
                <span style="font-weight: 600; font-size: 16px; color: #171717">Database</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">Table Name</span>
                  <v-autocomplete
                    class="model-input-control mt-2"
                    id="tablename-autocomplete-modelmanagement"
                    :placeholder="'Table Name'"
                    clearable
                    :items="listDataIntegration"
                    item-title="dataName"
                    item-value="id"
                    density="compact"
                    variant="none"
                    v-model="LLmsModel.DataIntegrationID"
                    hide-details
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'tablename-gptmodeldetail-option-' + index" :value="item.raw.dataName">
                        <template v-slot:title>
                          <span>{{ item.raw.dataName }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoDataIntegration') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <!-- <span>SQL Extraction Model</span> -->
                  <v-autocomplete
                    class="model-input-control mt-8"
                    id="sqlextractionmodel-autocomplete-modelmanagement"
                    clearable
                    :placeholder="'SQL Extraction Model'"
                    :items="listSqlExtract"
                    item-title="name"
                    item-value="modelDisplayID"
                    density="compact"
                    variant="none"
                    v-model="LLmsModel.SqlModelID"
                    hide-details
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'sqlextractionmodel-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoSQLExtractStatement') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="2">
                  <!-- <span style="color: transparent; pointer-events: none; user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none;" unselectable="on" aria-hidden="true">-</span> -->
                  <button type="button" id="button-customize-nodata-modelmanagement" class="no-data-message-button mt-8" @click="openPromptSqlNoDataDialog">
                    <img src="@/assets/plus.svg" alt="img" width="15" height="15" />
                    <span style="font-size: 13px; color: #c32e0e">Add prompt for no data</span>
                    <!-- {{promptSqlNoDataButtonText}} -->
                  </button>
                </v-col>

                <v-col cols="12" sm="12" md="2">
                  <button type="button" class="circle-button-no-data mt-10">
                    <img src="@/assets/cross-circle.svg" alt="img" width="15" height="15" />
                    <span style="color: #ffffff; font-size: 10px">No Data</span>
                  </button>
                </v-col>
              </v-row>

              <v-dialog v-model="promptSqlNoDataDialog" max-width="600" persistent>
                <v-card class="no-data-dialog-card" elevation="4">
                  <v-card-title class="d-flex align-center justify-space-between py-4 px-5">
                    <span class="text-h6 font-weight-bold">Customize No Data Message</span>
                    <v-btn id="button-close-nodata-dialog-modelmanagement" variant="text" icon="mdi-close" color="grey-darken-1" @click="cancelPromptSqlNoDataDialog"></v-btn>
                  </v-card-title>
                  <v-card-text class="px-5 pt-0 pb-2">
                    <v-textarea
                      id="promptsqlnodata-textarea-modelmanagement"
                      variant="outlined"
                      rows="7"
                      v-model="promptSqlNoDataDraft"
                      placeholder="Enter the text to display when no data is found"
                      auto-grow
                    ></v-textarea>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-4 px-5 justify-end">
                    <v-btn
                      id="button-cancel-nodata-dialog-modelmanagement"
                      class="dialog-close-btn mr-3"
                      variant="text"
                      color="grey-darken-1"
                      prepend-icon="mdi-close"
                      @click="cancelPromptSqlNoDataDialog"
                      >Close</v-btn
                    >
                    <v-btn id="button-save-nodata-dialog-modelmanagement" class="dialog-save-btn" color="white" variant="flat" @click="savePromptSqlNoData">
                      <v-img :src="newSaveImg" alt="Customize No Data Dialog" class="image-icon-style"></v-img>
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <div class="d-flex align-center justify-start mb-2 mt-4" style="gap: 8px">
                <img src="@/assets/product-bold.svg" alt="img" width="20" height="20" />
                <span style="font-weight: 600; font-size: 16px; color: #171717">Products</span>
              </div>
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <span class="mt-2" style="font-size: 14px; color: #171717">Product Group Name</span>
                  <v-autocomplete
                    class="model-input-control mt-2"
                    :placeholder="'Product Group Name'"
                    clearable
                    :items="DDProductGroup"
                    item-title="name"
                    density="compact"
                    chips
                    deletable-chips
                    item-value="id"
                    multiple
                    variant="none"
                    v-model="LLmsModel.productGroupID"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'productgroupname-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoGroupReplaceText') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12" md="4">
                  <span>Top-N Chunk</span>
                  <v-text-field
                    class="model-input-control mt-2"
                    id="product-top-n-chunks-field-modelmanagement"
                    :placeholder="'Top-N Chunks'"
                    density="compact"
                    :disabled="LLmsModel.productGroupID.length == 0"
                    v-model="LLmsModel.productTopVDB"
                    variant="none"
                    @keypress="isNumberpositive($event)"
                    :rules="[checkProductValidate()]"
                  >
                    <template v-slot:append-outer>
                      <v-tooltip location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoTopVDB') }}</span>
                      </v-tooltip>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card>

            <!-- Workflow -->

            <v-row class="mt-4" v-if="!workflowPanelOpen" @click="workflowPanelOpen = true">
              <v-col cols="12" sm="12">
                <div class="workflow-panel-body">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/mdi_workflow.svg" alt="Example" width="20" height="20" />
                    <span class="header" style="font-size: 18px">Workflow</span>
                  </div>
                  <button type="button" class="workflow-right">
                    <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
                  </button>
                </div>
              </v-col>
            </v-row>

            <v-card class="card2 mt-8" v-if="workflowPanelOpen">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex flex-column">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/mdi_workflow.svg" alt="img" width="20" height="20" />
                    <span class="header">Workflow</span>
                  </div>
                  <div>
                    <span class="workflow-header__subtitle" v-show="workflowPanelOpen">Configure workflow integration for this model</span>
                  </div>
                </div>
                <div class="mt-2 d-flex flex-row align-end">
                  <div class="chipdiv">
                    <div class="d-flex flex-column align-end">
                      <v-chip :class="{ 'flow-selected': LLmsModel.flowGroupID, 'flow-not-selected': !LLmsModel.flowGroupID }" size="small">
                        <v-icon :color="LLmsModel.flowGroupID ? '#04B439' : 'white'" class="mr-2" size="16">
                          {{ LLmsModel.flowGroupID ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                        {{ LLmsModel.flowGroupID ? 'Flow Connected' : 'No Flow Selected' }}
                      </v-chip>
                      <span class="mt-2 chipspan">Select a flow enable workflow integration</span>
                    </div>
                  </div>

                  <button type="button" @click="workflowPanelOpen = false">
                    <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
                  </button>
                </div>
              </div>

              <div class="mt-2">
                <hr />
              </div>

              <v-row class="mt-4">
                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex justify-start align-center" style="gap: 6px">
                    <img src="@/assets/code-branch-solid.svg" alt="img" width="20" height="20" />
                    <span style="color: #171717">Flow Configuration</span>
                  </div>
                  <v-select
                    class="model-input-control mt-2"
                    id="flow-dropdown-modelmanagement"
                    v-model="LLmsModel.flowGroupID"
                    :items="flowDropdown"
                    item-title="name"
                    item-value="flowGroupID"
                    density="compact"
                    variant="none"
                    placeholder="Select Flow"
                    clearable
                  >
                    <template v-slot:selection="{ item }">
                      <div>
                        <span class="font-weight-medium">{{ item.raw.name }}</span>
                      </div>
                    </template>

                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" class="flow-list-item" :id="'flow-gptmodeldetail-option-' + index" :value="item.raw.flowGroupID">
                        <template v-slot:prepend>
                          <v-avatar size="32" color="primary" variant="tonal">
                            <v-icon size="16" color="primary">mdi-chart-timeline-variant-shimmer</v-icon>
                          </v-avatar>
                        </template>
                        <template v-slot:title>
                          <span class="font-weight-medium">{{ item.raw.name }}</span>
                        </template>
                        <template v-slot:subtitle>
                          <span class="text-caption text-grey-darken-1"> Flow ID: {{ item.raw.flowGroupID }} </span>
                        </template>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex justify-start align-center" style="gap: 6px">
                    <img src="@/assets/ri_focus-3-line.svg" alt="img" width="20" height="20" />
                    <span style="color: #171717">Intent Detection</span>
                  </div>
                  <v-autocomplete
                    id="groupintent-autocomplete-modelmanagement"
                    placeholder="Select Intent"
                    clearable
                    :items="listDDIntentGroup"
                    item-title="name"
                    item-value="id"
                    density="compact"
                    variant="none"
                    class="model-input-control mt-2"
                    v-model="LLmsModel.IntentGroupID"
                    :disabled="intentAutocompleteDisabled"
                    :hint="intentHelperText"
                    :persistent-hint="intentAutocompleteDisabled"
                    hide-details="auto"
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'groupintent-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoDataIntegration') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" sm="12" md="4" v-if="LLmsModel.typeLLM == 0">
                  <div class="d-flex justify-start align-center" style="gap: 6px">
                    <img src="@/assets/majesticons_shield-line.svg" alt="img" width="20" height="20" />
                    <span style="color: #171717">Guard Rail</span>
                  </div>
                  <v-autocomplete
                    id="guardrailmodel-autocomplete-modelmanagement"
                    placeholder="Select Guard Rail"
                    clearable
                    :items="listGuardRailModel"
                    item-title="name"
                    item-value="modelDisplayID"
                    density="compact"
                    variant="none"
                    class="model-input-control mt-2"
                    v-model="LLmsModel.guardRailModelID"
                    hide-details
                  >
                    <template v-slot:item="{ props, item, index }">
                      <v-list-item v-bind="props" :id="'guardrail-gptmodeldetail-option-' + index" :value="item.raw.name">
                        <template v-slot:title>
                          <span>{{ item.raw.name }}</span>
                        </template>
                      </v-list-item>
                    </template>
                    <template v-slot:append-outer>
                      <v-tooltip location="top" max-width="300">
                        <template v-slot:activator="{ props }">
                          <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                        </template>
                        <span>{{ $t('_InfoSQLExtractStatement') }}</span>
                      </v-tooltip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card>

            <!-- <v-expansion-panels class="modern-panels" :elevation="3" v-model="workflowPanelOpen">
              <v-expansion-panel>
                <template v-slot:title>
                  <div class="d-flex align-items-center justify-space-between w-100">
                    <div style="padding-left: 22px;">
                      <div class="d-flex align-center panel-header py-2 workflow-header">
                        <div class="workflow-header__icon">
                          <v-icon color="#C32E0E" size="20">mdi-sitemap</v-icon>
                        </div>
                        <div class="workflow-header__text">
                          <span class="header">Workflow</span>
                        </div>
                      </div>
                      <span class="workflow-header__subtitle" v-show="workflowPanelOpen === 0">Configure workflow integration for this model</span>
                    </div>
                    
                    <div class="chipdiv" v-show="workflowPanelOpen === 0" >
                      <div class="d-flex flex-column align-end">
                        <v-chip 
                        :class="{ 'flow-selected': LLmsModel.flowGroupID, 'flow-not-selected': !LLmsModel.flowGroupID }"
                        size="small"
                      >
                        <v-icon 
                          :color="LLmsModel.flowGroupID ? 'green' : 'white'" 
                          class="mr-2"
                          size="16"
                        >
                          {{ LLmsModel.flowGroupID ? 'mdi-check-circle' : 'mdi-close-circle' }}
                        </v-icon>
                        {{ LLmsModel.flowGroupID ? 'Flow Connected' : 'No Flow Selected' }}
                      </v-chip>
                      <span class="mt-2 chipspan">Select a flow enable workflow integration</span>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:text>
                  
                  <v-row style="margin: 5px 0px; border-top: 1px solid #e5e7eb;margin-top: -22px;padding-top: 20px;"></v-row>
                  <v-row>
                    <v-col cols="4">
                      <div style="display: flex;flex-direction: column;">
                        <span class="mb-2"><v-icon class="mr-2">mdi-chart-timeline-variant-shimmer</v-icon>Flow Configuration</span>
                        <v-select id="flow-dropdown-modelmanagement" v-model="LLmsModel.flowGroupID"
                          :items="flowDropdown" item-title="name" item-value="flowGroupID"
                          density="comfortable" variant="outlined" clearable
                          class="flow-select-enhanced" placeholder="Select Flow">
                          <template v-slot:selection="{ item }">
                            <div>
                              <span class="font-weight-medium">{{ item.raw.name }}</span>
                            </div>
                          </template>

                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props" 
                              class="flow-list-item"
                              :id="'flow-gptmodeldetail-option-' + index"
                              :value="item.raw.flowGroupID">
                              <template v-slot:prepend>
                                <v-avatar size="32" color="primary" variant="tonal">
                                  <v-icon size="16" color="primary">mdi-chart-timeline-variant-shimmer</v-icon>
                                </v-avatar>
                              </template>
                              <template v-slot:title>
                                <span class="font-weight-medium">{{ item.raw.name }}</span>
                              </template>
                              <template v-slot:subtitle>
                                <span class="text-caption text-grey-darken-1">
                                  Flow ID: {{ item.raw.flowGroupID }}
                                </span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-select>
                      </div>
                    </v-col>
                    <v-col cols="4">
                      <div style="display: flex;flex-direction: column;">
                        <span class="mb-2"><v-icon class="mr-2">mdi-target</v-icon>Intent Detection</span>
                        <v-autocomplete id="groupintent-autocomplete-modelmanagement" placeholder="Select Intent"
                          :items="listDDIntentGroup" item-title="name" item-value="id" density="compact" clearable
                          variant="outlined" class="flow-select-enhanced autocomplete-field-c" v-model="LLmsModel.IntentGroupID"
                          :disabled="intentAutocompleteDisabled" :hint="intentHelperText"
                          :persistent-hint="intentAutocompleteDisabled" hide-details="auto">
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props"
                              :id="'groupintent-gptmodeldetail-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoDataIntegration") }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col cols="4" v-if="LLmsModel.typeLLM == 0">
                      <div style="display: flex;flex-direction: column;">
                        <span class="mb-2"><v-icon class="mr-2">mdi-shield-outline</v-icon>Guard Rail</span>
                        <v-autocomplete id="guardrailmodel-autocomplete-modelmanagement" placeholder="Select Guard Rail"
                          :items="listGuardRailModel" item-title="name" item-value="modelDisplayID" density="compact"
                          clearable variant="outlined" class="flow-select-enhanced autocomplete-field-c"
                          v-model="LLmsModel.guardRailModelID" hide-details>
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item 
                              v-bind="props" 
                              :id="'guardrail-gptmodeldetail-option-' + index" 
                              :value="item.raw.name"
                            >
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoSQLExtractStatement") }}</span>
                            </v-tooltip>
                          </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel>
            </v-expansion-panels> -->

            <!-- Model Setting -->
            <v-row class="mt-4" v-if="!modelSettingOpen" @click="modelSettingOpen = true">
              <v-col cols="12" sm="12">
                <div class="workflow-panel-body">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/config.svg" alt="Example" width="20" height="20" />
                    <span class="header" style="font-size: 18px">Model Setting</span>
                  </div>
                  <button type="button" class="workflow-right">
                    <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
                  </button>
                </div>
              </v-col>
            </v-row>

            <v-card class="card2 mt-8" v-if="modelSettingOpen">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center justify-start gap-2">
                  <img src="@/assets/config.svg" alt="img" width="20" height="20" />
                  <span class="header">Model Setting</span>
                </div>
                <div class="mt-2">
                  <button type="button" @click="modelSettingOpen = false">
                    <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
                  </button>
                </div>
              </div>

              <div class="mt-2">
                <hr />
              </div>

              <div>
                <v-row class="memory-card mt-4 mx-1">
                  <v-col cols="8" style="height: 160px">
                    <div class="memory-card__short">
                      <div class="memory-section-header d-flex align-center">
                        <img src="@/assets/5a410419-c731-4277-877c-bd68c49236af.svg" alt="img" width="24" height="24" />
                        <h4 class="memory-title">Short-Term Memory</h4>
                      </div>
                      <v-row class="memory-input-row" dense>
                        <v-col cols="4" class="col-label-input">
                          <span>Turn</span>
                          <v-text-field
                            id="turn-memory-modelmanagement"
                            :placeholder="'Turn'"
                            clearable
                            variant="outlined"
                            density="comfortable"
                            v-model="LLmsModel.historyCount"
                            class="rounded-input"
                            @keypress="isNumberpositive($event)"
                            min="0"
                            hide-details
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoTurn') }} </span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" class="col-label-input">
                          <span>Character/Turn</span>
                          <v-text-field
                            id="short-term-memory-modelmanagement"
                            :placeholder="'Character/Turn'"
                            clearable
                            density="comfortable"
                            class="rounded-input"
                            variant="outlined"
                            v-model="LLmsModel.Len_ShortMemory"
                            @keypress="numericKey"
                            min="1"
                            hide-details
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoShortMemory') }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                        <v-col cols="4" class="col-label-input">
                          <span>Duration (Minute)</span>
                          <v-text-field
                            id="duration-memory-modelmanagement"
                            :placeholder="'Duration (Minute)'"
                            clearable
                            variant="outlined"
                            density="comfortable"
                            class="rounded-input"
                            v-model="LLmsModel.historyMinute"
                            @keypress="isNumber($event)"
                            hide-details
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top">
                                <template v-slot:activator="{ props }">
                                  <v-icon text size="x-small" style="position: absolute; top: 0px; right: 0px" v-bind="props">mdi-information-outline</v-icon>
                                </template>
                                <span>{{ $t('_InfoMinute') }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                  <v-col cols="4" style="height: 160px; display: flex; align-items: flex-start">
                    <v-divider vertical class="memory-card__divider ml-3"></v-divider>

                    <div class="memory-card__long" style="margin-left: 20px">
                      <div class="memory-section-header" style="display: flex; flex-direction: column; align-items: flex-start">
                        <div class="memory-icon">
                          <img src="@/assets/1b437834-ee3e-445e-b215-0fe31a31ccde.svg" alt="img" width="24" height="24" />
                          <h4 class="memory-title">Long-Term Memory</h4>
                        </div>
                        <div style="margin-top: 20px; padding-left: 10px; display: flex; justify-content: flex-start; flex-direction: column">
                          <p class="memory-status mb-0">{{ longTermMemoryStatus }}</p>

                          <v-tooltip location="top" max-width="300px">
                            <template v-slot:activator="{ props }">
                              <v-switch v-bind="props" id="checkbox-longterm-memory-modelmanagement" class="memory-switch" v-model="LLmsModel.IsLongTerm_Memory"> </v-switch>
                            </template>
                            <span>Previous chat turns are saved and retrieved with RAG for better context understanding.</span>
                          </v-tooltip>

                          <!-- <v-switch id="checkbox-longterm-memory-modelmanagement" class="memory-switch" v-model="LLmsModel.IsLongTerm_Memory">
                            <template v-slot:label>
                              <v-tooltip location="top" max-width="300">
                                <template v-slot:activator="{ props }">
                                  <label class="sr-only" v-bind="props">Toggle Long-Term Memory</label>
                                </template>
                                <span>{{ $t("_InfoLongtermMemory") }}</span>
                              </v-tooltip>
                            </template>
                          </v-switch> -->
                        </div>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- Enable Mutiple-Turn Input -->
                <v-row class="multi-turn-section align-center pl-1" dense>
                  <v-col cols="12" sm="12" md="3">
                    <div class="multi-turn-toggle">
                      <span style="font-weight: 600">{{ $t('_InfoMultiTurnInput') }}</span>
                      <v-tooltip location="top" max-width="330px">
                        <template v-slot:activator="{ props }">
                          <v-switch v-bind="props" id="enablemulti-turninput-checkbox-modelmanagement" class="memory-switch mt-6" v-model="LLmsModel.IsChainMassage"> </v-switch>
                        </template>
                        <span>Allows the model to process several user inputs or prompts sequentially in a single turn.</span>
                      </v-tooltip>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" md="3" style="margin-top: -28px">
                    <div>
                      <span>Sequence</span>
                      <v-text-field
                        class="model-input-control mt-2"
                        id="sequence-field-modelmanagement"
                        :placeholder="'Sequence'"
                        density="comfortable"
                        :disabled="!LLmsModel.IsChainMassage"
                        v-model="LLmsModel.LenChainMassage"
                        variant="none"
                        @keypress="isNumberpositive($event)"
                        :rules="[checkValidate()]"
                      >
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t('_InfoSequence') }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" md="3" style="margin-top: -28px">
                    <div>
                      <span>Duration (Seconds)</span>
                      <v-text-field
                        class="model-input-control mt-2"
                        id="duration-field-modelmanagement"
                        :placeholder="'Duration (Seconds)'"
                        density="comfortable"
                        :disabled="!LLmsModel.IsChainMassage"
                        v-model="LLmsModel.TimeSecondChainMassage"
                        variant="none"
                        @keypress="isNumberpositive($event)"
                        :rules="[checkValidate()]"
                      >
                        <template v-slot:append-outer>
                          <v-tooltip location="top">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t('_InfoTimeSeconds') }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </div>
                  </v-col>
                </v-row>

                <!-- Parameters -->
                <v-row style="margin-top: -20px; padding-left: 3px">
                  <v-col cols="12">
                    <span style="font-weight: 600; font-size: 18px">Parameters</span>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <span>Temperature (0-1)</span>
                    <v-text-field
                      id="temperature-field-modelmanagement"
                      :placeholder="'Temperature'"
                      class="model-input-control"
                      v-model="LLmsModel.temperature"
                      density="compact"
                      @keypress="isNumber($event)"
                      variant="none"
                      :rules="[validateInput0_1(LLmsModel.temperature)]"
                      required
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoTemperature') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <span>Top P (0-1)</span>
                    <v-text-field
                      id="topP-field-modelmanagement"
                      :placeholder="'Top P'"
                      class="model-input-control"
                      v-model="LLmsModel.topP"
                      @keypress="isNumber($event)"
                      variant="none"
                      density="compact"
                      :disabled="LLmsModel.provider == 'Anthropic'"
                      :rules="[validateInput0_1(LLmsModel.topP)]"
                      required
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoTopP') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <span>Frequency Penalty (0-2)</span>
                    <v-text-field
                      id="frequency-penalty-modelmanagement"
                      :placeholder="'Frequency Penalty'"
                      class="model-input-control"
                      :disabled="LLmsModel.provider == 'Anthropic'"
                      v-model="LLmsModel.frequencyPenalty"
                      @keypress="isNumber($event)"
                      variant="none"
                      density="compact"
                      :rules="[validateInput0_2(LLmsModel.frequencyPenalty)]"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoFrequencyPenalty') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <span>Presence Penalty (0-2)</span>
                    <v-text-field
                      id="presence-penalty-modelmanagement"
                      :placeholder="'Presence Penalty'"
                      class="model-input-control"
                      :disabled="LLmsModel.provider == 'Anthropic'"
                      v-model="LLmsModel.presencePenalty"
                      @keypress="isNumber($event)"
                      variant="none"
                      density="compact"
                      :rules="[validateInput0_2(LLmsModel.presencePenalty)]"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoPresencePenalty') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <span>Max Tokens Response</span>
                    <v-text-field
                      id="max-tokens-response-modelmanagement"
                      :placeholder="'Max Tokens Response'"
                      class="model-input-control"
                      variant="none"
                      density="compact"
                      @keypress="isNumberpositive($event)"
                      v-model="LLmsModel.maxTokens"
                      :error="error.maxTokens.error"
                      :error-messages="error.maxTokens.message"
                    >
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>{{ $t('_InfoMaxToken') }}</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <span>Stop Sequence</span>
                    <v-text-field id="stop-sequence-modelmanagement" :placeholder="'Stop Sequence'" class="model-input-control" v-model="LLmsModel.stop" variant="none" density="compact">
                      <template v-slot:append-outer>
                        <v-tooltip location="top" max-width="300">
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                          <span>
                            {{ $t('_InfoStop') }}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12" md="4">
                    <span>Gender</span>
                    <v-select
                      id="gender-autocomplete-modelmanagement"
                      v-model="LLmsModel.gender"
                      :items="DDGender"
                      class="model-input-control"
                      item-title="name"
                      item-value="id"
                      placeholder="Gender"
                      density="compact"
                      variant="none"
                    />
                  </v-col>
                </v-row>
              </div>
            </v-card>

            <!-- <v-expansion-panels class="modern-panels" :elevation="3">
              <v-expansion-panel>
                <template v-slot:title>
                  <div class="d-flex align-center panel-header py-2" style="padding-left: 22px;">
                    <Icon icon="lets-icons:setting-alt-fill" style="font-size: 22px;color: #C32E0E" />
                    <span class="header">Model Setting</span>
                  </div>
                </template>
                <template v-slot:text>
                  <v-row style="margin: 5px 0px; border-top: 1px solid #e5e7eb;margin-top: -22px;padding-top: 20px;"></v-row>
                  <div class="memory-section-wrapper">
                    <v-row class="memory-card">
                      <v-col cols="8" style="height: 160px;">
                        <div class="memory-card__short">
                          <div class="memory-section-header">
                            <div class="memory-icon">
                              <Icon icon="fluent:brain-circuit-28-filled" style="font-size: 28px;color: #C32E0E" />
                            </div>
                            <div>
                              <h4 class="memory-title">Short-Term Memory</h4>
                            </div>
                          </div>
                          <v-row class="memory-input-row" dense>
                            <v-col cols="4" class="col-label-input">
                              <span>Turn</span>
                              <v-text-field id="turn-memory-modelmanagement" :placeholder="'Turn'" clearable
                                variant="outlined" density="comfortable" v-model="LLmsModel.historyCount"
                                class="rounded-input"
                                @keypress="isNumberpositive($event)" min="0" hide-details>
                                <template v-slot:append-outer>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon text size="x-small" style="
                                            position: absolute;
                                            top: 0px;
                                            right: -6px;
                                          " v-bind="props">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t("_InfoTurn") }} </span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="col-label-input">
                              <span>Character/Turn</span>
                              <v-text-field id="short-term-memory-modelmanagement" :placeholder="'Character/Turn'" clearable
                                density="comfortable" class="rounded-input" variant="outlined" v-model="LLmsModel.Len_ShortMemory"
                                @keypress="numericKey" min="1" hide-details>
                                <template v-slot:append-outer>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon text size="x-small" style="
                                            position: absolute;
                                            top: 0px;
                                            right: -6px;
                                          " v-bind="props">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t("_InfoShortMemory") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="4" class="col-label-input">
                              <span>Duration (Minute)</span>
                              <v-text-field id="duration-memory-modelmanagement" :placeholder="'Duration (Minute)'" clearable
                                variant="outlined" density="comfortable" class="rounded-input" v-model="LLmsModel.historyMinute"
                                @keypress="isNumber($event)" hide-details>
                                <template v-slot:append-outer>
                                  <v-tooltip location="top">
                                    <template v-slot:activator="{ props }">
                                      <v-icon text size="x-small" style="
                                            position: absolute;
                                            top: 0px;
                                            right: 0px;
                                          " v-bind="props">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ $t("_InfoMinute") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </div>
                      </v-col>
                      <v-col cols="4" style="height: 160px;display: flex;align-items: flex-start;">

                        <v-divider vertical class="memory-card__divider ml-3"></v-divider>

                        <div class="memory-card__long" style="margin-left: 20px;">
                          <div class="memory-section-header" style="display: flex;flex-direction: column;align-items: flex-start;">
                            <div class="d-flex align-center">
                              <img src="@/assets/1b437834-ee3e-445e-b215-0fe31a31ccde.svg" alt="img" width="24" height="24" />
                              <h4 class="memory-title">Long-Term Memory</h4>
                            </div>
                            <div style="margin-top: 20px;padding-left: 10px;display: flex;justify-content: flex-start;flex-direction: column;">
                              <p class="memory-status mb-0">{{ longTermMemoryStatus }}</p>
                              <v-switch id="checkbox-longterm-memory-modelmanagement"
                              style="margin-left: -6px;"
                              :class="[
                                    'publication-toggle',
                                    LLmsModel.IsLongTerm_Memory
                                      ? 'publication-toggle--active'
                                      : 'publication-toggle--inactive'
                                  ]"inset hide-details
                                :aria-label="$t('_InfoLongtermMemory')"
                                :disabled="LLmsModel.provider == 'Google'" v-model="LLmsModel.IsLongTerm_Memory">
                                <template v-slot:label>
                                  <v-tooltip location="top" max-width="300">
                                    <template v-slot:activator="{ props }">
                                      <label class="sr-only" v-bind="props">Toggle Long-Term Memory</label>
                                    </template>
                                    <span>{{ $t("_InfoLongtermMemory") }}</span>
                                  </v-tooltip>
                                </template>
                              </v-switch>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>

                  <v-row class="multi-turn-section align-center" dense>
                    <v-col cols="8" class="d-flex align-center" style="gap: 26px;">
                      <div class="multi-turn-toggle">
                        <span style="font-weight: 500;">{{ $t('_InfoMultiTurnInput') }}</span>
                        <v-switch id="enablemulti-turninput-checkbox-modelmanagement" inset
                          :class="[
                            'publication-toggle',
                            LLmsModel.IsChainMassage
                              ? 'publication-toggle--active'
                              : 'publication-toggle--inactive'
                          ]"
                          hide-details v-model="LLmsModel.IsChainMassage">
                        </v-switch>
                      </div>
                      <div class="col-label-input" style="min-width: 300px;">
                        <span>Sequence</span>
                        <v-text-field id="sequence-field-modelmanagement" :placeholder="'Sequence'" density="comfortable"
                          :disabled="!LLmsModel.IsChainMassage" v-model="LLmsModel.LenChainMassage" clearable
                          variant="outlined" @keypress="isNumberpositive($event)" :rules="[checkValidate()]"
                          hide-details>
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoSequence") }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </div>
                      <div class="col-label-input" style="min-width: 300px;">
                        <span>Duration (Seconds)</span>
                        <v-text-field id="duration-field-modelmanagement" :placeholder="'Duration (Seconds)'" density="comfortable"
                          :disabled="!LLmsModel.IsChainMassage" v-model="LLmsModel.TimeSecondChainMassage" clearable
                          variant="outlined" @keypress="isNumberpositive($event)" :rules="[checkValidate()]"
                          hide-details>
                          <template v-slot:append-outer>
                            <v-tooltip location="top">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="
                                      position: absolute;
                                      top: 0px;
                                      right: -6px;
                                    " v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t("_InfoTimeSeconds") }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </div>
                    </v-col>
                  </v-row>

                  
                  <v-row>
                    <v-col cols="12">
                      <span style="font-weight: 500;">Parameters</span>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Temperature (0-1)</span>
                      <v-text-field id="temperature-field-modelmanagement" :placeholder="'Temperature'"
                        class="rounded-input padding-input2"
                        v-model="LLmsModel.temperature" density="compact" @keypress="isNumber($event)"
                        variant="outlined" :rules="[validateInput0_1(LLmsModel.temperature)]" required>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoTemperature") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Top P (0-1)</span>
                      <v-text-field id="topP-field-modelmanagement" :placeholder="'Top P'"
                        class="rounded-input padding-input2"
                         v-model="LLmsModel.topP"
                        @keypress="isNumber($event)" variant="outlined" density="compact"
                        :disabled="LLmsModel.provider == 'Anthropic'" :rules="[validateInput0_1(LLmsModel.topP)]"
                        required>
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoTopP") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Frequency Penalty (0-2)</span>
                      <v-text-field id="frequency-penalty-modelmanagement" :placeholder="'Frequency Penalty'"
                        class="rounded-input padding-input2"
                        :disabled="LLmsModel.provider == 'Anthropic'" v-model="LLmsModel.frequencyPenalty"
                        @keypress="isNumber($event)" variant="outlined" density="compact" :rules="[
                          validateInput0_2(LLmsModel.frequencyPenalty),
                        ]">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoFrequencyPenalty") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Presence Penalty (0-2)</span>
                      <v-text-field id="presence-penalty-modelmanagement" :placeholder="'Presence Penalty'"
                        class="rounded-input padding-input2"
                        :disabled="LLmsModel.provider == 'Anthropic'" v-model="LLmsModel.presencePenalty"
                        @keypress="isNumber($event)" variant="outlined" density="compact"
                        :rules="[validateInput0_2(LLmsModel.presencePenalty)]">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoPresencePenalty") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Max Tokens Response</span>
                      <v-text-field id="max-tokens-response-modelmanagement" :placeholder="'Max Tokens Response'"
                        class="rounded-input padding-input2"
                         clearable
                        variant="outlined" density="compact" @keypress="isNumberpositive($event)"
                        v-model="LLmsModel.maxTokens" :error="error.maxTokens.error"
                        :error-messages="error.maxTokens.message">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>{{ $t("_InfoMaxToken") }}</span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="4" class="col-label-input">
                      <span>Stop Sequence</span>
                      <v-text-field id="stop-sequence-modelmanagement" :placeholder="'Stop Sequence'"
                        class="rounded-input padding-input2"
                         v-model="LLmsModel.stop"
                        variant="outlined" density="compact">
                        <template v-slot:append-outer>
                          <v-tooltip location="top" max-width="300">
                            <template v-slot:activator="{ props }">
                              <v-icon text size="x-small" style="
                                    position: absolute;
                                    top: 0px;
                                    right: -6px;
                                  " v-bind="props">mdi-information-outline</v-icon>
                            </template>
                            <span>
                              {{ $t("_InfoStop") }}
                            </span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </v-col>
                    
                    <v-col cols="4" class="col-label-input">
                      <span>Gender</span>
                      <v-select id="gender-autocomplete-modelmanagement" v-model="LLmsModel.gender" :items="DDGender"
                        class="rounded-input padding-input2"
                        item-title="name" item-value="id" placeholder="Gender" density="compact" variant="outlined"/>
                    </v-col>
                  </v-row>
                  
                </template>
              </v-expansion-panel>
            </v-expansion-panels> -->

            <!-- Chat Setting -->
            <v-row class="mt-4" v-if="!chatSettingOpen" @click="chatSettingOpen = true">
              <v-col cols="12" sm="12">
                <div class="workflow-panel-body">
                  <div class="d-flex align-center justify-start gap-2">
                    <img src="@/assets/fluent_settings-chat-16-filled.svg" alt="Example" width="20" height="20" />
                    <span class="header" style="font-size: 18px">Chat Setting</span>
                  </div>
                  <button type="button" class="workflow-right">
                    <img src="@/assets/arrow-drop-down.svg" alt="expand" width="16" height="16" />
                  </button>
                </div>
              </v-col>
            </v-row>

            <v-card class="card2 mt-8" v-if="chatSettingOpen">
              <div class="d-flex align-center justify-space-between">
                <div class="d-flex align-center justify-start gap-2">
                  <img src="@/assets/fluent_settings-chat-16-filled.svg" alt="img" width="20" height="20" />
                  <span class="header">Chat Setting</span>
                </div>
                <div class="mt-2">
                  <button type="button" @click="chatSettingOpen = false">
                    <img src="@/assets/arrow-drop-up.svg" alt="img" width="16" height="16" />
                  </button>
                </div>
              </div>

              <div class="mt-2">
                <hr />
              </div>

              <!-- Stream Response -->
              <v-row class="mt-4">
                <v-col cols="12" sm="12" md="4">
                  <v-card
                    class="option-card d-flex flex-column mt-1"
                    :class="{ 'option-active': LLmsModel.isStream }"
                    :style="LLmsModel.isStream ? 'background: #FFF2F2;' : ''"
                    flat
                    height="100%"
                    min-height="78px"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <div class="option-header">
                        <div class="d-flex align-center gap-2">
                          <span style="font-weight: 600">Stream Response</span>
                          <v-tooltip top max-width="320">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                            </template>
                            <span>Deliver the Bot’s answer in real-time, appearing token-by-token as it's generated.</span>
                          </v-tooltip>
                        </div>
                        <div class="grey--text text-caption mt-1" v-if="LLmsModel.isStream">Chat response appears gradually while loading</div>
                        <div class="grey--text text-caption mt-1" v-else>Full chat response displays after processing</div>
                      </div>
                      <v-switch id="switch-stream-ModelManagement" v-model="LLmsModel.isStream" class="memory-switch"></v-switch>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex align-center gap-2">
                    <span :style="LLmsModel.isStream ? '' : 'color:rgba(55, 65, 81, 0.6);'">Typing Delay (ms)</span>
                    <v-tooltip location="top" max-width="320">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                      </template>
                      <!-- <span>The time (in milliseconds) the system waits after you stop typing before processing the full input.</span> -->
                      <span>Sets the delay between each character displayed during streaming. The value is in milliseconds (ms)</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="typingspeed-field-modelmanagement"
                    v-model.number="LLmsModel.typingSpeed"
                    class="model-input-control mt-2"
                    :class="LLmsModel.isStream ? 'input--enabled' : 'input--disabled'"
                    :readonly="!LLmsModel.isStream"
                    placeholder="Typing Speed"
                    type="number"
                    min="0"
                    density="compact"
                    variant="none"
                    @keypress="isNumberpositive($event)"
                    persistent-hint
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <div class="d-flex align-center gap-2">
                    <span>Max Input Length</span>
                    <v-tooltip location="top" max-width="320">
                      <template v-slot:activator="{ props }">
                        <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                      </template>
                      <span>Set the maximum number of characters allowed per message.</span>
                    </v-tooltip>
                  </div>
                  <v-text-field
                    id="maxinputlength-field-modelmanagement"
                    v-model.number="LLmsModel.maximumChatInput"
                    placeholder="Max Input Length"
                    type="number"
                    min="0"
                    max="999999"
                    density="compact"
                    variant="none"
                    class="model-input-control mt-2"
                    :rules="[rules.required]"
                    @keypress="maxNumberpositive($event)"
                    persistent-hint
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Collect Feedback -->
              <v-row>
                <v-col cols="12" sm="12" md="4">
                  <v-card
                    class="option-card d-flex flex-column"
                    :class="{ 'option-active': LLmsModel.isFeedback }"
                    :style="LLmsModel.isFeedback ? 'background: #FFF2F2;' : ''"
                    flat
                    height="100%"
                    min-height="80px"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <div class="option-header">
                        <div class="d-flex align-center gap-2">
                          <span style="font-weight: 600">Collect Feedback</span>
                          <v-tooltip top max-width="420">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                            </template>
                            <span>Enable user ratings and reporting of responses to help improve the model's accuracy and behavior.</span>
                          </v-tooltip>
                        </div>
                        <div class="grey--text text-caption mt-1">Allow users to rate responses</div>
                      </div>
                      <v-switch id="switch-feedback-ModelManagement" v-model="LLmsModel.isFeedback" class="memory-switch"></v-switch>
                    </div>
                  </v-card>
                </v-col>

                <!--  Image Upload Settings -->
                <v-col cols="12" sm="12" md="8">
                  <v-row class="mr-1" :style="LLmsModel.isAllowImage ? 'background: #FFF2F2; border-radius: 10px; max-height: 80px; margin-top:0px; margin-left:0px' : ''">
                    <v-col cols="6" :style="LLmsModel.isAllowImage ? 'padding-top: 0px; padding-left:0px;' : 'padding-top: 12px;'">
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card
                            class="option-card d-flex flex-column"
                            :class="{
                              'on-hover': hover,
                              'option-active': LLmsModel.isAllowImage && showFileUpload,
                            }"
                            flat
                            height="100%"
                            :style="LLmsModel.isAllowImage ? 'background: #FFF2F2;' : ''"
                            :min-height="LLmsModel.isAllowImage && showFileUpload ? '80px' : '80px'"
                          >
                            <div class="d-flex justify-space-between align-center">
                              <!-- Left Side (Label + Info) -->
                              <div class="option-header">
                                <div class="d-flex align-center gap-2">
                                  <span style="font-weight: 600">Image Upload</span>
                                  <v-tooltip location="top" max-width="380">
                                    <template v-slot:activator="{ props }">
                                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                                    </template>
                                    <span>Enable users to upload images alongside text prompts for multimodal processing.</span>
                                  </v-tooltip>
                                </div>
                                <p class="grey--text text-caption mt-1">Allow users to upload images for analysis</p>
                              </div>

                              <!-- Switch -->
                              <v-switch id="fileupload-checkbox-modelmanagement" v-model="LLmsModel.isAllowImage" class="memory-switch" color="primary" :disabled="!modelSupportsFileUpload"></v-switch>
                            </div>
                          </v-card>
                        </template>
                      </v-hover>
                    </v-col>

                    <v-col cols="6" :style="LLmsModel.isAllowImage ? 'padding-top: 0px;' : 'padding-top: 12px;'">
                      <v-card
                        class="d-flex flex-column pt-3"
                        :class="{ 'option-active': LLmsModel.isAllowImage }"
                        :style="LLmsModel.isAllowImage ? 'background: #FFF2F2;' : ''"
                        flat
                        height="100%"
                        min-height="80px"
                      >
                        <div v-if="LLmsModel.isAllowImage" class="additional-content d-flex align-end">
                          <v-text-field
                            v-if="LLmsModel.isAllowImage && showFileUpload"
                            id="fileuploadlimit-field-modelmanagement"
                            placeholder="Maximum file size"
                            @keypress="validateNumber($event)"
                            @paste="validateNumber($event)"
                            v-model.number="LLmsModel.fileUploadLimit"
                            density="compact"
                            variant="outlined"
                            hide-details="auto"
                            class="rounded-input padding-input input--enabled"
                            hint="Recommended: 1024KB for most cases"
                            persistent-hint
                            :rules="[rules.required]"
                            :disabled="!modelSupportsFileUpload"
                          >
                            <template v-slot:append-inner>
                              <v-chip size="small" color="blue-grey lighten-1" text-color="white" class="file-size-chip"> KB </v-chip>
                            </template>

                            <template v-slot:append>
                              <v-tooltip location="top" max-width="300">
                                <template v-slot:activator="{ props }">
                                  <v-icon small color="grey-darken-1" v-bind="props" class="info-icon-enhanced"> mdi-information-outline </v-icon>
                                </template>
                                <span>{{ $t('_InfoMaximumFileUpload') }}</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <!-- LLM Selection -->
              <v-row class="mr-1">
                <v-col cols="12" sm="12" md="4">
                  <v-card
                    class="option-card d-flex flex-column"
                    :class="{ 'option-active': LLmsModel.isAllowLLMChange }"
                    :style="LLmsModel.isAllowLLMChange ? 'background: #FFF2F2;' : ''"
                    flat
                    height="100%"
                    min-height="80px"
                  >
                    <div class="d-flex justify-space-between align-start">
                      <div class="option-header">
                        <div class="d-flex align-center gap-2">
                          <span style="font-weight: 600">LLM Selection</span>
                          <v-tooltip top max-width="330">
                            <template v-slot:activator="{ props }">
                              <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                            </template>
                            <span>Select the core AI model to use. Different models impact speed, cost, and response capabilities.</span>
                          </v-tooltip>
                        </div>
                        <div class="grey--text text-caption mt-1">Allow model switching in chat</div>
                      </div>
                      <v-switch id="llm-selection-switch-modelmanagement" v-model="LLmsModel.isAllowLLMChange" class="memory-switch"></v-switch>
                    </div>
                  </v-card>
                </v-col>

                <!-- Time Settings -->
                <v-col cols="8">
                  <v-row :style="LLmsModel.enableTime ? 'background: #FFF2F2; border-radius: 10px; max-height: 80px; margin-top:0px; margin-left:0px' : ''">
                    <v-col cols="6" :style="LLmsModel.enableTime ? 'padding-top: 0px; padding-left:0px;' : 'padding-top: 12px;'">
                      <v-hover>
                        <template v-slot:default="{ hover }">
                          <v-card
                            class="option-card d-flex flex-column"
                            :class="{
                              'on-hover': hover,
                              'option-active': LLmsModel.enableTime,
                            }"
                            :style="LLmsModel.enableTime ? 'background: #FFF2F2;' : ''"
                            flat
                            height="100%"
                            min-height="80px"
                          >
                            <div class="d-flex justify-space-between align-start">
                              <div class="option-header">
                                <div class="d-flex align-center gap-2">
                                  <span style="font-weight: 600">Time Context</span>
                                  <v-tooltip location="top" max-width="400">
                                    <template v-slot:activator="{ props }">
                                      <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                                    </template>
                                    <span>Inject the current date and time into the prompt, allowing the AI to answer time-sensitive questions accurately.</span>
                                  </v-tooltip>
                                </div>
                                <div class="grey--text text-caption mt-1">Enable time awareness in responses</div>
                              </div>
                              <v-switch id="Enabletime-modelmanagement" v-model="LLmsModel.enableTime" class="memory-switch"></v-switch>
                            </div>
                          </v-card>
                        </template>
                      </v-hover>
                    </v-col>
                    <v-col cols="6" :style="LLmsModel.enableTime ? 'padding-top: 0px;' : 'padding-top: 12px;'">
                      <v-card
                        class="d-flex flex-column"
                        :class="{ 'option-active': LLmsModel.enableTime }"
                        :style="LLmsModel.enableTime ? 'background: #FFF2F2;' : ''"
                        flat
                        height="100%"
                        min-height="80px"
                      >
                        <div v-if="LLmsModel.enableTime" style="margin-top: 12px" class="additional-content">
                          <v-select
                            id="timezone-modelmanagement"
                            v-model="LLmsModel.timeZone"
                            :items="DDTimeZone"
                            item-title="name"
                            item-value="value"
                            placeholder="Time Zone"
                            density="compact"
                            variant="none"
                            hide-details="auto"
                            background-color="white"
                            class="model-input-control"
                          >
                            <template v-slot:selection="{ item }">
                              <div style="padding: 7px" class="timezone-selection d-flex align-center">
                                <v-icon small color="primary" class="mr-2">mdi-map-marker</v-icon>
                                <span class="font-weight-medium">{{ item.raw.name }}</span>
                                <v-chip size="x-small" color="grey-darken-1" text-color="white" class="ml-2 timezone-code">
                                  {{ item.raw.value.split('/')[1].replace('_', ' ') }}
                                </v-chip>
                              </div>
                            </template>

                            <template v-slot:item="{ props, item, index }">
                              <v-list-item v-bind="props" class="timezone-item" :id="'timezone-modelmanagement-option-' + index" :value="item.raw.name">
                                <template v-slot:title>
                                  <div class="timezone-item-content">
                                    <span class="timezone-country font-weight-medium" style="margin-left: 5px">{{ item.raw.name }}</span>
                                    <div class="timezone-details d-flex align-center mt-1">
                                      <v-chip size="x-small" color="grey-darken-1" text-color="white" class="timezone-code">{{ item.raw.value.replace('_', ' ') }} </v-chip>
                                    </div>
                                  </div>
                                </template>
                              </v-list-item>
                            </template>
                          </v-select>
                        </div>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row>
                <!-- Reasoning Effort -->
                <v-col cols="4">
                  <transition name="fade">
                    <v-card
                      v-if="showReasoningEffort"
                      class="option-card d-flex flex-column mb-3"
                      style="background-color: #fff2f2"
                      :class="{ 'option-active': LLmsModel.reasoningEffort }"
                      flat
                      height="100%"
                      min-height="90px"
                    >
                      <div class="d-flex justify-space-between align-start">
                        <div class="option-header mb-auto">
                          <div class="d-flex align-center">
                            <span style="font-weight: 600">Reasoning Effort</span>
                            <v-tooltip top max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon small color="grey lighten-1" v-bind="props" class="ml-1">mdi-information-outline</v-icon>
                              </template>
                              <span>Level of reasoning depth for responses</span>
                            </v-tooltip>
                          </div>
                        </div>
                      </div>

                      <v-select
                        id="reasoning-ModelManagement"
                        v-model="LLmsModel.reasoningEffort"
                        :items="reasonOptions"
                        :class="LLmsModel.reasoningEffort ? 'input--enabled' : 'input--disabled'"
                        :rules="showReasoningEffort ? [rules.required] : [rules.notRequired]"
                        item-title="text"
                        item-value="value"
                        density="compact"
                        variant="outlined"
                        hide-details
                        placeholder="Select level"
                        class="mt-1 rounded-input padding-input"
                      >
                        <template v-slot:item="{ props, item, index }">
                          <v-list-item v-bind="props" :id="'reasoningeffort-gptmodeldetail-option-' + index" :value="item.raw.text">
                            <template v-slot:title>
                              <span>{{ item.raw.text }}</span>
                            </template>
                          </v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div class="d-flex align-center">
                            <v-chip size="small" :color="getReasoningColor(item.raw.value)" text-color="white" class="px-3 reasoning-chip">
                              {{ item.raw.text }}
                            </v-chip>
                          </div>
                        </template>
                      </v-select>
                    </v-card>
                  </transition>
                </v-col>
              </v-row>

              <!-- Line Configuration -->
              <div class="pa-3">
                <v-row style="background-color: #fff2f2; border-radius: 15px; padding: 8px">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex align-center justify-start gap-2">
                          <img src="@/assets/ri_line-fill.svg" alt="Line Icon" width="20" height="20" />
                          <span style="font-size: 18px; font-weight: 600">Line Configuration</span>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex align-center">
                      <v-col cols="3" class="mt-4">
                        <v-switch
                          id="loadingbar-enabled-switch-modelmanagement"
                          class="memory-switch"
                          v-model="LLmsModel.loadingBarFlag"
                          :label="`Loading bar (${LLmsModel.loadingBarFlag ? 'Enabled' : 'Disabled'})`"
                          color="primary"
                          @click="disabledConfig()"
                        ></v-switch>
                      </v-col>
                      <v-col cols="4" style="margin-top: -36px">
                        <span>Loading duration</span>
                        <v-autocomplete
                          id="loadingduration-autocomplete-modelmanagement"
                          :placeholder="'Loading duration'"
                          clearable
                          class="model-input-control mt-2"
                          :class="LLmsModel.loadingBarFlag ? 'input--enabled' : 'input--disabled'"
                          :items="listLoadingDuration"
                          variant="none"
                          density="compact"
                          v-model="LLmsModel.loadingBarDuration"
                          :disabled="!LLmsModel.loadingBarFlag"
                          persistent-hint
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'loadingduration-gptmodeldetail-option-' + index" :value="item.raw">
                              <template v-slot:title>
                                <span>{{ item.raw }}</span>
                              </template>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>

                    <!-- Monitor -->
                    <v-row style="margin-top: -16px">
                      <v-col cols="12">
                        <span style="font-size: 18px; font-weight: 600">Monitor</span>
                      </v-col>
                    </v-row>
                    <v-row style="margin-top: -8px">
                      <v-col cols="12" sm="12" md="4">
                        <span>Monitor Line UserID</span>
                        <v-text-field
                          id="monitor-line-userid-modelmanagement"
                          :placeholder="'Monitor Line UserID'"
                          class="model-input-control mt-2"
                          v-model="LLmsModel.monitorLineUserID"
                          variant="none"
                          density="compact"
                        >
                          <template v-slot:append-outer>
                            <v-tooltip location="top" max-width="300">
                              <template v-slot:activator="{ props }">
                                <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                              </template>
                              <span>{{ $t('_InfoMonitorLINEUserid') }}</span>
                            </v-tooltip>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="4">
                        <span>Monitor Line Name</span>
                        <v-autocomplete
                          id="monitor-line-name-modelmanagement"
                          :placeholder="'Monitor Line Name'"
                          class="model-input-control mt-2"
                          :items="listMonitorLineName"
                          density="compact"
                          clearable
                          variant="none"
                          item-title="name"
                          :class="LLmsModel.monitorSocialID ? 'input--enabled' : 'input--disabled'"
                          item-value="id"
                          v-model="LLmsModel.monitorSocialID"
                        >
                          <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" :id="'monitor-line-name-gptmodeldetail-option-' + index" :value="item.raw.name">
                              <template v-slot:title>
                                <span>{{ item.raw.name }}</span>
                              </template>
                            </v-list-item>
                          </template>
                          <template v-slot:activator="{ props }">
                            <v-icon text size="x-small" style="position: absolute; top: 0px; right: -6px" v-bind="props">mdi-information-outline</v-icon>
                          </template>
                        </v-autocomplete>
                      </v-col>

                      <v-col cols="12" sm="12" md="4">
                        <v-card
                          class="option-card d-flex flex-column"
                          :class="{ 'option-active': LLmsModel.isShowNameUserMonitor }"
                          flat
                          height="100%"
                          :style="LLmsModel.isShowNameUserMonitor ? 'background: #FFFFFF;' : 'background: #EDEDED;'"
                          min-height="78px"
                        >
                          <div class="d-flex justify-space-between align-start">
                            <div class="option-header">
                              <div class="d-flex align-center gap-2">
                                <span class="font-weight-medium">Show Line Name</span>
                                <v-tooltip location="top">
                                  <template v-slot:activator="{ props }">
                                    <img v-bind="props" src="@/assets/intent group toolip.svg" alt="img" width="18" height="18" />
                                  </template>
                                  <span>Turn on to include Line Names in the monitoring view.</span>
                                </v-tooltip>
                              </div>
                              <div class="grey--text text-caption mt-1">Include line name in monitoring interface</div>
                            </div>
                            <v-switch id="showname-usermonitor-switch" v-model="LLmsModel.isShowNameUserMonitor" class="memory-switch" @click="disabledConfig()"></v-switch>
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>

                    <!-- Forbidden Word -->
                    <v-row>
                      <v-col cols="12">
                        <v-toolbar-title style="font-size: 18px">Forbidden word</v-toolbar-title>
                      </v-col>
                    </v-row>
                    <div class="forbidden-container">
                      <div v-if="!LLmsModel.forbiddenWord || LLmsModel.forbiddenWord.length === 0" class="forbidden-empty">
                        <span>No forbidden words added yet.</span>
                      </div>
                      <transition-group name="forbidden-fade" tag="div" class="forbidden-list">
                        <div class="forbidden-item" v-for="(item, index) in LLmsModel.forbiddenWord" :key="`forbidden-${index}`">
                          <div class="forbidden-index">{{ index + 1 }}</div>
                          <v-text-field
                            :id="`forbiddenword-textfield-${index}`"
                            v-model="LLmsModel.forbiddenWord[index]"
                            variant="outlined"
                            density="compact"
                            class="forbidden-input"
                            placeholder="Enter forbidden word"
                            hide-details
                            @keydown.enter.prevent
                          >
                            <template v-slot:append-outer>
                              <v-tooltip location="top" :open-delay="500">
                                <template v-slot:activator="{ props }">
                                  <v-icon size="16" color="#9CA3AF" style="cursor: help" v-bind="props"> mdi-information-outline </v-icon>
                                </template>
                                <span>Words or phrases to block from responses</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                          <v-btn icon="mdi-delete-outline" variant="text" color="grey-darken-1" class="forbidden-delete" @click="removeForbiddenWord(index)">
                            <v-tooltip location="top" :open-delay="300">
                              <template v-slot:activator="{ props }">
                                <v-icon size="18" color="#EF4444" v-bind="props">mdi-delete-forever</v-icon>
                              </template>
                              <span>Remove</span>
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </transition-group>
                      <div class="forbidden-footer">
                        <button type="button" id="button-add-forbiddenword-modelmanagement" class="forbidden-add-btn" @click="addForbiddenWord">
                          <img src="@/assets/plus.svg" alt="Plus Icon" width="16" height="16" />
                          <span style="color: #c32e0e; font-size: 14px">Add Word</span>
                        </button>
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="page.includes('Playground')" cols="12" class="d-flex justify-end">
            <div style="display: flex; gap: 18px">
              <button type="button" class="add-example-section" @click="closePlayground">
                <img src="@/assets/line-md_close.svg" alt="img" width="16" height="16" />
                <span style="font-weight: 400; font-size: 14px; color: #c30000">{{ $t('close') }}</span>
              </button>
              <button type="button" class="footer-btn save" @click="savePlayground">
                <img src="@/assets/basil_save-solid.png" alt="img" width="20" height="20" />
                <span>{{ $t('save') }}</span>
              </button>
            </div>
          </v-col>
          <v-col v-else-if="page == 'Model Creator'" cols="12" justify="end" align="end">
            <!-- <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px"
                    to="/GPTModelManagement">CLOSE</v-btn>
                  <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 89.863px"
                    @click="Save('s')">SAVE</v-btn>
                  <v-btn class="white--text mt-3"
                    style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 120px"
                    @click="Save('s&c')">SAVE & CLOSE</v-btn> -->
          </v-col>
          <v-col v-else cols="12" justify="end" align="end">
            <div v-if="page != 'view model'">
              <v-btn class="dialog-close-btn" style="margin-left: 1em; border-radius: 25.342px; background: #faa91b; width: 89.863px" to="/GPTModelManagement">
                <Icon icon="line-md:close" style="font-size: 22px; color: #c32e0e; margin-right: 8px" />
                CLOSE
              </v-btn>
              <v-btn
                id="button-saveandclose-modelmanagement"
                class="dialog-save-btn"
                style="margin-left: 1em; border-radius: 25.342px; background: #9747ff; width: 180px !important"
                :disabled="saveLoading"
                @click="Save('s&c')"
              >
                <img src="@/assets/fluent_save-arrow-right-24-filled.png" alt="img" width="20" height="20" />
                SAVE & CLOSE
              </v-btn>
              <v-btn class="dialog-save-btn-green" style="margin-left: 1em; border-radius: 25.342px; width: 89.863px" :disabled="saveLoading" @click="Save('s')">
                <Icon icon="basil:save-solid" style="font-size: 22px; color: #ffffff; margin-right: 8px" />
                SAVE
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-dialog v-model="dialogShowAll" width="500">
        <v-card max-width="500">
          <v-list density="compact" rounded>
            <v-subheader class="headline" style="color: #1d4f81; font-size: 20px; border-radius: 5px; writing-mode: horizontal-tb">Prompt Template</v-subheader>
            <v-divider :thickness="1" class="border-opacity-100"></v-divider>
            <v-container style="max-height: 400px; overflow-y: auto; overflow-x: hidden">
              <v-list-item v-for="(item, i) in filteredPromptTemplates" :key="i" @click="SetSelectPromptTemplate(item)">
                <template v-slot:title>
                  <span :id="'list-nameprompttemplateall-modelmanagement-legacy-' + i">{{ item.name }}</span>
                </template>
              </v-list-item>
            </v-container>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn id="button-close-popupshowall-legacy-modelmanagement" color="blue darken-1" variant="text" @click="dialogShowAll = false">
              {{ $t('close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>

    <!-- Add Category Dialog -->
    <v-dialog v-model="dialog_addCategory" max-width="560px" persistent>
      <v-card style="border-radius: 16px !important; overflow: hidden;">
        <div style="background: linear-gradient(180deg, #ffffff 0%, #eef4ff 100%); display: flex; justify-content: space-between; align-items: center; padding: 14px 12px 14px 24px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon color="#1976D2" size="22">mdi-tag-multiple-outline</v-icon>
            <span style="font-size: 18px; font-weight: 600; color: #1976D2;">Manage Categories</span>
          </div>
          <v-btn icon variant="text" size="small" @click="closeCategoryDialog">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="padding: 24px 24px 16px 24px;">
          <v-combobox
            v-model="newCategoryName"
            :items="categoryNameOptions"
            label="Search or add category"
            variant="outlined"
            density="comfortable"
            :rules="[categoryNameRequiredRule]"
            no-data-text="Type a new tag to add"
            :menu-props="{ maxHeight: 260 }"
            prepend-inner-icon="mdi-tag-search-outline"
            autofocus
            clearable
            @keydown.enter.prevent="SaveCategory"
            hide-details="auto"
            style="border-radius: 12px;"
          />

          <div class="category-manager-summary">
            <span class="category-manager-label">Existing Categories</span>
            <v-chip size="small" color="#E3F2FD" text-color="#1565C0">{{ filteredCategoryDialogItems.length }}</v-chip>
          </div>

          <div class="category-manager-list">
            <div v-if="filteredCategoryDialogItems.length === 0" class="category-manager-empty">
              <v-icon size="18" color="#90A4AE">mdi-tag-off-outline</v-icon>
              <span>No categories found</span>
            </div>
            <div
              v-for="category in filteredCategoryDialogItems"
              :key="category.id || category.name"
              class="category-manager-item"
            >
              <div class="category-manager-name">
                <v-icon size="16" color="#1976D2">mdi-tag-outline</v-icon>
                <span>{{ category.name }}</span>
              </div>
              <div class="category-manager-actions">
                <v-btn icon variant="text" size="small" @click="openRenameCategoryDialog(category)">
                  <v-icon size="18" color="#1976D2">mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon variant="text" size="small" @click="deleteCategory(category)">
                  <v-icon size="18" color="#D32F2F">mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px 24px; display: flex; justify-content: flex-end; gap: 10px;">
          <v-btn class="delete-cancel-btn" @click="closeCategoryDialog">Cancel</v-btn>
          <v-btn
            style="background: linear-gradient(90deg, #1976D2 0%, #42A5F5 100%) !important; color: white !important; border-radius: 11px !important; height: 40px !important; min-width: 100px !important; text-transform: none !important; font-weight: 500 !important; box-shadow: 0 2px 8px rgba(25,118,210,0.25) !important;"
            :disabled="!normalizeCategoryDisplayName(newCategoryName)"
            @click="SaveCategory"
          >
            <v-icon left size="18" style="margin-right: 4px;">mdi-plus-circle-outline</v-icon>
            Add
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_renameCategory" max-width="420px" persistent>
      <v-card style="border-radius: 16px !important; overflow: hidden;">
        <div style="background: linear-gradient(180deg, #ffffff 0%, #eef4ff 100%); display: flex; justify-content: space-between; align-items: center; padding: 14px 12px 14px 24px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <v-icon color="#1976D2" size="22">mdi-tag-edit-outline</v-icon>
            <span style="font-size: 18px; font-weight: 600; color: #1976D2;">Rename Category</span>
          </div>
          <v-btn icon variant="text" size="small" @click="closeRenameCategoryDialog">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text style="padding: 24px 24px 16px 24px;">
          <v-text-field
            v-model="renameCategoryName"
            label="New category name *"
            variant="outlined"
            density="comfortable"
            :rules="[categoryNameRequiredRule]"
            autofocus
            @keydown.enter.prevent="RenameCategory"
            hide-details="auto"
            style="border-radius: 12px;"
          />
        </v-card-text>
        <v-card-actions style="padding: 0 24px 16px 24px; display: flex; justify-content: flex-end; gap: 10px;">
          <v-btn class="delete-cancel-btn" @click="closeRenameCategoryDialog">Cancel</v-btn>
          <v-btn
            style="background: linear-gradient(90deg, #1976D2 0%, #42A5F5 100%) !important; color: white !important; border-radius: 11px !important; height: 40px !important; min-width: 100px !important; text-transform: none !important; font-weight: 500 !important; box-shadow: 0 2px 8px rgba(25,118,210,0.25) !important;"
            :disabled="!normalizeCategoryDisplayName(renameCategoryName)"
            @click="RenameCategory"
          >
            <v-icon left size="18" style="margin-right: 4px;">mdi-content-save-edit-outline</v-icon>
            Rename
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="400" :model-value="saveLoading || dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular indeterminate size="64" color="primary" class="mb-4"></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from '@/api/function.js';
import LogTrace from '@/api/function.js';
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import lineIcon from '@/assets/brand/line-icon.png';
import newSaveImg from '@/assets/Icons/white-save-floppy.svg';

export default {
  name: 'ModelManagement',
  mixins: [checkPermissionTwo, LogTrace],
  props: {
    LLmsModel: {
      type: Object,
      default: () => {
        return {
          typeLLM: 0,
          modelId: null,
          modelName: null,
          provider: null,
          model: null,
          APIVersion: null,
          extension: null,
          description: null,
          promptTemplate: '',
          gender: null,
          vectordbName: [],
          groupReplaceID: null,
          productGroupID: [],
          topVDB: null,
          productTopVDB: null,
          productCosine: null,
          internet: null,
          feedback: null,
          historyCount: null,
          historyMinute: null,
          temperature: null,
          topP: null,
          frequencyPenalty: null,
          presencePenalty: null,
          stop: null,
          maxTokens: null,
          isStream: false,
          isBypass: false,
          isFeedback: false,
          isAllowImage: false,
          fileUploadLimit: null,
          versioning: null,
          isPublish: true,
          modelIDGroup: null,
          modelDisplay: null,
          Len_ShortMemory: null,
          IsLongTerm_Memory: false,
          IsChainMassage: false,
          LenChainMassage: null,
          TimeSecondChainMassage: null,
          Cosine: null,
          DataIntegrationID: null,
          SqlModelID: null,
          promptSqlNoData: null,
          guardRailModelID: null,
          IntentGroupID: null,
          maximumChatInput: 200000,
          loadingBarFlag: false,
          loadingBarDuration: 0,
          forbiddenWord: [''],
          monitorLineUserID: null,
          monitorSocialID: null,
          isShowNameUserMonitor: false,
          modelType: null,
          styleImage: null,
          resFormatImage: null,
          quality: null,
          resolution: null,
          enableTime: null,
          timeZone: null,
          jsonRequest: null,
          reasoningEffort: null,
          endPointURL: null,
          apI_Key: null,
          isAllowLLMChange: false,
          flowGroupID: null,
          platform: null,
          categoryName: null,
        };
      },
    },
    // DDVector:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDataIntegration:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listSqlExtract:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDGroupReplace:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // DDPromptTemplate:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDProvider:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDModel:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    // listDDIntentGroup:{
    //     type: Array,
    //     default: ()=>{
    //         return [];
    //     }
    // },
    GetDDModel: {
      type: String,
      default: null,
    },
    // editAction: {
    //   type: Boolean,
    //   default: false,
    // },
    modelID: {
      type: String,
      default: null,
    },
    page: {
      type: String,
      default: '-',
    },
  },
  data: () => ({
    id: null,
    activeTab: 0,
    valid: true,
    checkbox1: false,
    dialog: false,
    tempID: 0,
    MenuID1: null,
    MenuID2: null,
    MenuID3: null,
    menuID: null,
    subMenuID: null,
    today: null,
    maxLengthChar: null,
    loading: true,
    switch1: true,
    enableFlag: false,
    txtToImgChecker: false,
    imageStyleOptions: [
      { text: 'Natural', value: 'natural' },
      { text: 'Vivid', value: 'vivid' },
    ],
    imageFormatOptions: [
      { text: 'URL', value: 'url' },
      { text: 'Base64 json', value: 'b64_json' },
    ],
    reasonOptions: [
      { text: 'Low', value: 'low' },
      { text: 'Medium', value: 'medium' },
      { text: 'High', value: 'high' },
    ],
    rules: {
      notRequired: () => true,
      required: (value) => !!value || 'Required.',
    },
    GPTModel_isPublish: false,
    DDVector: [],
    DDGroupReplace: [],
    DDProductGroup: [],
    DDProvider: ['Azure', 'Google'],
    listDataIntegration: [],
    listSqlExtract: [],
    listGuardRailModel: [],
    DDMinute: [
      {
        name: '0',
        value: 0,
      },
      {
        name: '2',
        value: -2,
      },
      {
        name: '10',
        value: -10,
      },
      {
        name: '30',
        value: -30,
      },
      {
        name: '60',
        value: -60,
      },
      {
        name: '720',
        value: -720,
      },
      {
        name: '1440',
        value: -1440,
      },
    ],
    DDModel: [
      {
        provider: 'Azure',
        model: 'gpt-35-turbo-chat',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure',
        model: 'gpt-35-turbo-16k',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure',
        model: 'gpt-4',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-35-postgresql',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-35-16k-postgresql',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure Postgresql',
        model: 'gpt-4-postgresql',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-35-Internet',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-35-16k-Internet',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure Internet',
        model: 'gpt-4-Internet',
        maxPrompt: 6000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-35-turbo-chat',
        maxPrompt: 4000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-35-turbo-16k',
        maxPrompt: 8000,
      },
      {
        provider: 'Azure News',
        model: 'gpt-4',
        maxPrompt: 6000,
      },
    ],
    DDModelShow: [],
    DDGender: [
      {
        id: 'm',
        name: 'Male',
      },
      {
        id: 'f',
        name: 'Female',
      },
    ],
    DDTimeZone: [
      {
        value: 'Asia/Bangkok',
        name: 'Thailand',
      },
      {
        value: 'Asia/Hong_Kong',
        name: 'Hong Kong',
      },
      {
        value: 'Asia/Tokyo',
        name: 'Japan',
      },
      {
        value: 'America/New_York',
        name: 'USA',
      },
      {
        value: 'Europe/London',
        name: 'England',
      },
      {
        value: 'Australia/Sydney',
        name: 'Australia',
      },
    ],
    images: {
      edit: editImg,
      delete: deleteImg,
      line: lineIcon,
    },
    listDDModel: [],
    listDDIntentGroup: [],
    listDDProvider: [],
    platformOptions: [
      { text: 'Azure', value: 'Azure' },
        // { text: 'AWS Bedrock', value: 'AWS Bedrock' },
        { text: 'Google Vertex AI', value: 'Google' },
        // { text: 'Grok API (xAI)', value: 'Grok API (xAI)' },
        { text: 'Anthropic Direct', value: 'Anthropic' },
        // { text: 'OpenAI Direct', value: 'OpenAI' },
        // { text: 'Together AI', value: 'Together AI' },
        // { text: 'Fireworks AI', value: 'Fireworks AI' },
        // { text: 'DeepInfra', value: 'DeepInfra' },
        { text: 'Other', value: 'Other' },
    ],
    showMenu: false,
    x: 0,
    y: 0,
    DDPromptTemplate: [],
    DDGroupPromptTemplate: [],
    flowDropdown: [],
    PositionPromptTemplate: 0,
    showPromptTem: false,
    dialogShowAll: false,
    promptSqlNoDataDialog: false,
    promptSqlNoDataDraft: '',
    groupPromptTemplate: null,
    localEditAction: null,
    categories: [],
    categoryMenuOpen: false,
    dialog_addCategory: false,
    newCategoryName: '',
    dialog_renameCategory: false,
    renameCategoryName: '',
    renameCategoryTarget: null,
    listLoadingDuration: [10, 20, 30, 40, 50, 60],
    listMonitorLineName: [],
    showFileUpload: false,
    showReasoningEffort: false,
    saveLoading: false,
    totalTokens: null,
    intentAutocompleteDisabled: false,
    workflowPanelOpen: false,
    modelSettingOpen: false,
    chatSettingOpen: false,
    error: {
      maxTokens: {
        error: false,
        message: '',
      },
    },
    newSaveImg: newSaveImg,
  }),

  watch: {
    // editAction(newVal) {
    //   this.localEditAction = newVal;
    // },
    '$route.params.id': function (newParam) {
      // อัพเดตค่าพารามิเตอร์ด้วยตัวเอง
      this.id = newParam;
    },
    'LLmsModel.provider': function (val) {
      if (val == null) {
        this.LLmsModel.vectordbName = [];
        this.LLmsModel.topVDB = null;
        this.LLmsModel.productGroupID = [];
        this.LLmsModel.productTopVDB = null;
      }
    },
    'LLmsModel.flowGroupID': {
      handler(newVal) {
        if (newVal) {
          this.LLmsModel.IntentGroupID = null;
        }
        this.intentAutocompleteDisabled = Boolean(newVal);
      },
      immediate: true,
    },
    LLmsModel(val) {
      if (!val) {
        return;
      }

      if (val.platform) {
        this.changePlatform(val.platform, { preserveModel: true });
      } else if (val.provider) {
        this.changeProvider(val.provider, { preserveModel: true });
      }

      if (val.model) {
        this.changeModel(this.buildModelSelectionValue(val.model, val.modelNameDisplay));
      }
    },
  },
  computed: {
    categoryOptions() {
      return this.dedupeCategories(this.categories);
    },
    categoryNameOptions() {
      return this.categoryOptions.map((category) => category.name);
    },
    filteredCategoryDialogItems() {
      const keyword = this.normalizeCategoryName(this.newCategoryName);
      const items = this.categoryOptions;

      if (!keyword) {
        return items;
      }

      return items.filter((category) => this.normalizeCategoryName(category.name).includes(keyword));
    },
    availableProviders() {
      if (!this.LLmsModel.platform) {
        return [];
      }

      return this.getProviderOptionsForPlatform(this.LLmsModel.platform);
    },
    isProviderSelectionDisabled() {
      return !this.LLmsModel.platform || Boolean(this.getFixedProviderByPlatform(this.LLmsModel.platform));
    },
    isModelSelectionDisabled() {
      return false;
    },
    modelSelectionOptions() {
      return Array.isArray(this.listDDModel) ? this.listDDModel : [];
    },
    selectedModelInfo() {
      return this.findModelDefinition(this.LLmsModel?.model, this.modelSelectionOptions);
    },
    providerSelectionRules() {
      return [this.validateProviderSelection];
    },
    modelSelectionRules() {
      return [this.validateModelSelection];
    },
    modelNoDataText() {
      return 'No data available';
    },
    modelSupportsFileUpload() {
      const selectedModel = this.findModelDefinition(this.LLmsModel.model, this.modelSelectionOptions);
      return selectedModel ? selectedModel.useUploadFile : false;
    },
    filteredPromptTemplates() {
      if (this.groupPromptTemplate === null) {
        return [];
      }
      return this.DDPromptTemplate.filter((item) => item.groupPromptTemplateID === this.groupPromptTemplate);
    },
    searchedTemplates() {
      if (!this.templateSearchQuery) return this.filteredPromptTemplates;
      const query = this.templateSearchQuery.toLowerCase();
      return this.filteredPromptTemplates.filter((item) => item.name.toLowerCase().includes(query));
    },
    intentHelperText() {
      return this.intentAutocompleteDisabled ? '*You cannot select an Intent while a Flow is active.' : '';
    },
    promptSqlNoDataButtonIcon() {
      const value = this.LLmsModel?.promptSqlNoData;
      if (!value || value.trim() === '') {
        return 'mdi-plus';
      }
      return 'mdi-check';
    },
    promptSqlNoDataButtonText() {
      const value = this.LLmsModel?.promptSqlNoData;
      if (!value || value.trim() === '') {
        return 'Customize No Data Message';
      }
      return 'Using Custom Message';
    },
    longTermMemoryStatus() {
      const isEnabled = Boolean(this.LLmsModel?.IsLongTerm_Memory);
      return isEnabled ? 'Long-Term Memory Enabled' : 'Long-Term Memory Disabled';
    },
  },
  methods: {
    normalizeLookupValue(value) {
      return typeof value === 'string' ? value.trim().toLowerCase() : '';
    },
    normalizeCategoryDisplayName(value) {
      return typeof value === 'string' ? value.trim().replace(/\s+/g, ' ') : '';
    },
    normalizeCategoryName(value) {
      return this.normalizeCategoryDisplayName(value).toLowerCase();
    },
    categoryNameRequiredRule(value) {
      const rawValue = typeof value === 'object' ? value?.name : value;
      return !!this.normalizeCategoryDisplayName(rawValue) || 'Required';
    },
    normalizeCategoryOption(category) {
      if (!category) {
        return null;
      }

      const categoryName = this.normalizeCategoryDisplayName(
        typeof category === 'string' ? category : (category.name ?? category.categoryName)
      );

      if (!categoryName) {
        return null;
      }

      return {
        id: typeof category === 'object' ? (category.id ?? category.categoryID ?? null) : null,
        name: categoryName,
      };
    },
    dedupeCategories(categories) {
      const seen = new Set();

      return (Array.isArray(categories) ? categories : [])
        .map((category) => this.normalizeCategoryOption(category))
        .filter((category) => {
          if (!category) {
            return false;
          }

          const normalizedName = this.normalizeCategoryName(category.name);
          if (!normalizedName || seen.has(normalizedName)) {
            return false;
          }

          seen.add(normalizedName);
          return true;
        });
    },
    findExistingCategory(name) {
      const normalizedName = this.normalizeCategoryName(name);

      if (!normalizedName) {
        return null;
      }

      return this.categoryOptions.find((category) => this.normalizeCategoryName(category.name) === normalizedName) || null;
    },
    findCategoryByName(name, excludeId = null) {
      const normalizedName = this.normalizeCategoryName(name);

      if (!normalizedName) {
        return null;
      }

      return this.categoryOptions.find((category) => {
        if (excludeId !== null && category.id === excludeId) {
          return false;
        }

        return this.normalizeCategoryName(category.name) === normalizedName;
      }) || null;
    },
    syncSelectedCategoryName() {
      const existingCategory = this.findExistingCategory(this.LLmsModel?.categoryName);
      if (existingCategory) {
        this.LLmsModel.categoryName = existingCategory.name;
        return;
      }

      const normalizedName = this.normalizeCategoryDisplayName(this.LLmsModel?.categoryName);
      this.LLmsModel.categoryName = normalizedName || null;
    },
    reloadCategories(selectedCategoryName = null) {
      let self = this;

      try {
        if (typeof self.$call.GetGPTModelCategory !== 'function') {
          return;
        }

        self.$call.GetGPTModelCategory(
          (res) => {
            if (res && res.status == 0) {
              self.categories = self.dedupeCategories(res.data || []);
              if (selectedCategoryName !== null) {
                self.LLmsModel.categoryName = selectedCategoryName;
              }
              self.syncSelectedCategoryName();
            }
          },
          () => {}
        );
      } catch (e) {}
    },
    matchesProvider(providerName, selectedProvider) {
      const normalizedProviderName = this.normalizeLookupValue(providerName);
      const normalizedSelectedProvider = this.normalizeLookupValue(selectedProvider);
      return normalizedProviderName !== '' && normalizedProviderName === normalizedSelectedProvider;
    },
    matchesPlatform(modelPlatform, selectedPlatform) {
      const normalizedSelectedPlatform = this.normalizeLookupValue(selectedPlatform);
      const normalizedModelPlatform = this.normalizeLookupValue(modelPlatform);

      if (!normalizedSelectedPlatform) {
        return false;
      }

      return normalizedModelPlatform === normalizedSelectedPlatform;
    },
    matchesModelSelection(model, selectedProvider, selectedPlatform) {
      if (!this.matchesProvider(model?.provider, selectedProvider)) {
        return false;
      }

      return this.matchesPlatform(model?.platform, selectedPlatform);
    },
    getAllProviderOptions() {
      const providerMap = new Map();

      const registerProvider = (providerName, source = {}) => {
        const normalizedProviderName = this.normalizeLookupValue(providerName);
        if (!normalizedProviderName) {
          return;
        }

        if (!providerMap.has(normalizedProviderName)) {
          providerMap.set(normalizedProviderName, {
            ...source,
            providerName: typeof providerName === 'string' ? providerName.trim() : providerName,
          });
        }
      };

      if (Array.isArray(this.listDDProvider)) {
        this.listDDProvider.forEach((provider) => {
          registerProvider(provider?.providerName ?? provider?.provider, provider);
        });
      }

      if (Array.isArray(this.listDDModel)) {
        this.listDDModel.forEach((model) => {
          registerProvider(model?.provider, { providerName: model?.provider });
        });
      }

      return Array.from(providerMap.values());
    },
    getProviderOptionsForPlatform(platform) {
      const allProviderOptions = this.getAllProviderOptions();
      const fixedProvider = this.getFixedProviderByPlatform(platform);

      if (fixedProvider) {
        const fixedProviderOptions = allProviderOptions.filter((provider) => this.matchesProvider(provider.providerName, fixedProvider));
        return fixedProviderOptions.length > 0 ? fixedProviderOptions : [{ providerName: fixedProvider }];
      }

      if (this.normalizeLookupValue(platform) === 'azure') {
        return allProviderOptions.filter((provider) => {
          const providerName = this.normalizeLookupValue(provider.providerName);
          return providerName !== 'google' && providerName !== 'other';
        });
      }

      return allProviderOptions;
    },
    getModelsForSelection(provider, platform) {
      if (!Array.isArray(this.listDDModel) || this.listDDModel.length === 0) {
        return [];
      }

      return this.listDDModel.filter((model) => this.matchesModelSelection(model, provider, platform));
    },
    getFixedProviderByPlatform(platform) {
      const map = {
        Google: 'Google',
        Anthropic: 'Anthropic',
      };

      return map[platform] ?? null;
    },
    getModelValueParts(value) {
      const raw = typeof value === 'string' ? value.trim() : '';
      if (!raw) {
        return { raw: '', model: '', display: '' };
      }

      const parts = raw.split('|');
      const model = (parts.shift() || '').trim();
      const display = parts.length > 0 ? parts.join('|').trim() : '';
      return { raw, model, display };
    },
    getModelSelectionDisplay(model) {
      return model?.modelDisplay || this.getModelValueParts(model?.modelName).display || model?.modelName || '';
    },
    buildModelSelectionValue(model, modelNameDisplay) {
      const rawModel = typeof model === 'string' ? model.trim() : '';
      const display = typeof modelNameDisplay === 'string' ? modelNameDisplay.trim() : '';

      if (!rawModel) {
        return display;
      }

      if (rawModel.includes('|') || !display) {
        return rawModel;
      }

      return `${rawModel}|${display}`;
    },
    isAnthropicValue(value) {
      const normalizedValue = this.normalizeLookupValue(value);
      return normalizedValue.includes('anthropic') || normalizedValue.includes('claude');
    },
    requiresApiVersion(platform = this.LLmsModel.platform, provider = this.LLmsModel.provider) {
      return this.isAnthropicValue(platform) || this.isAnthropicValue(provider);
    },
    isApiVersionMissing() {
      const apiVersion = typeof this.LLmsModel.APIVersion === 'string' ? this.LLmsModel.APIVersion.trim() : this.LLmsModel.APIVersion;
      return this.requiresApiVersion() && (apiVersion == '' || apiVersion == null);
    },
    getApiVersionForSave() {
      if (!this.requiresApiVersion()) {
        return null;
      }

      return typeof this.LLmsModel.APIVersion === 'string' ? this.LLmsModel.APIVersion.trim() : this.LLmsModel.APIVersion;
    },
    getComparableModelValues(value) {
      if (typeof value !== 'string') {
        return [];
      }

      const parts = this.getModelValueParts(value);
      const normalizedValue = this.normalizeModelValue(value);
      const modelWithDisplay = this.buildModelSelectionValue(parts.model, parts.display);

      return [...new Set([parts.raw, modelWithDisplay, normalizedValue, parts.display, parts.model].filter(Boolean))];
    },
    findModelDefinition(value, models = this.listDDModel) {
      if (!Array.isArray(models) || models.length === 0 || typeof value !== 'string') {
        return null;
      }

      const target = this.getModelValueParts(value);
      const normalize = (targetValue) => this.normalizeLookupValue(targetValue);
      const exactValue = models.find((model) => normalize(model?.modelName) === normalize(target.raw));
      if (exactValue) {
        return exactValue;
      }

      if (target.display) {
        const exactDisplay = models.find((model) => {
          const modelParts = this.getModelValueParts(model?.modelName);
          return normalize(model?.modelDisplay) === normalize(target.display) && (!target.model || normalize(modelParts.model) === normalize(target.model));
        });
        if (exactDisplay) {
          return exactDisplay;
        }
      }

      const displayOnly = models.find((model) => normalize(model?.modelDisplay) === normalize(target.raw));
      if (displayOnly) {
        return displayOnly;
      }

      const normalizedValue = normalize(this.normalizeModelValue(value));
      const normalizedMatch = models.find((model) => normalize(this.normalizeModelValue(model?.modelName)) === normalizedValue);
      if (normalizedMatch) {
        return normalizedMatch;
      }

      return models.find((model) => normalize(this.getModelValueParts(model?.modelName).model) === normalize(target.model || target.raw)) || null;
    },
    resetModelSelection() {
      this.LLmsModel.model = null;
      this.totalTokens = null;
      this.maxLengthChar = null;
      this.txtToImgChecker = false;
      this.showReasoningEffort = false;
      this.showFileUpload = false;
      this.LLmsModel.isAllowImage = false;
      this.LLmsModel.fileUploadLimit = null;
      this.LLmsModel.styleImage = null;
      this.LLmsModel.resFormatImage = null;
      this.LLmsModel.quality = null;
      this.LLmsModel.resolution = null;
      this.LLmsModel.modelType = null;
      this.LLmsModel.APIVersion = null;
      this.LLmsModel.jsonRequest = null;
      this.LLmsModel.reasoningEffort = null;
      this.LLmsModel.endPointURL = null;
      this.LLmsModel.apI_Key = null;
      this.LLmsModel.authenHeaderName = null;
    },
    handleProviderChange(value) {
      return this.changeProvider(value);
    },
    handleModelChange(value) {
      return this.changeModel(value);
    },
    validateProviderSelection(value) {
      if (!this.LLmsModel.platform) {
        return 'Please select platform first.';
      }

      return !!value || 'Required.';
    },
    validateModelSelection(value) {
      if (!value) {
        return 'Required.';
      }

      return value.split('')[0] !== '|' || 'Please select model';
    },
    openPromptSqlNoDataDialog() {
      this.promptSqlNoDataDraft = this.LLmsModel?.promptSqlNoData ?? '';
      this.promptSqlNoDataDialog = true;
    },
    cancelPromptSqlNoDataDialog() {
      this.promptSqlNoDataDialog = false;
      this.promptSqlNoDataDraft = this.LLmsModel?.promptSqlNoData ?? '';
    },
    savePromptSqlNoData() {
      const value = this.promptSqlNoDataDraft?.trim();
      this.LLmsModel.promptSqlNoData = value && value !== '' ? value : null;
      this.promptSqlNoDataDialog = false;
    },
    getReasoningColor(level) {
      switch (level) {
        case 'low':
          return 'blue-grey';
        case 'medium':
          return 'blue darken-1';
        case 'high':
          return 'indigo darken-2';
        default:
          return 'grey';
      }
    },
    truncatePrompt(text) {
      if (!text) return '';
      return text.length > 60 ? text.substring(0, 60) + '...' : text;
    },
    addForbiddenWord() {
      if (!Array.isArray(this.LLmsModel.forbiddenWord)) {
        this.LLmsModel.forbiddenWord = [''];
      } else {
        this.LLmsModel.forbiddenWord.push('');
      }

      const newIndex = this.LLmsModel.forbiddenWord.length - 1;
      this.$nextTick(() => {
        const input = this.$el?.querySelector(`#forbiddenword-textfield-${newIndex} input`);
        if (input) {
          input.focus();
        }
      });
    },
    removeForbiddenWord(index) {
      if (!Array.isArray(this.LLmsModel.forbiddenWord) || this.LLmsModel.forbiddenWord.length === 0) {
        return;
      }

      if (this.LLmsModel.forbiddenWord.length <= 1) {
        this.LLmsModel.forbiddenWord.splice(0, 1, '');
      } else {
        this.LLmsModel.forbiddenWord.splice(index, 1);
      }
    },
    disabledConfig() {
      return (this.enableFlag = !this.LLmsModel.loadingBarFlag);
    },
    ShowPromptTemplate(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.showMenu = true;
      });
    },
    async SetSelectPromptTemplate(val) {
      let self = this;
      var strArray = self.LLmsModel.promptTemplate.split('');
      strArray.splice(self.PositionPromptTemplate, 0, val.prompt);
      self.LLmsModel.promptTemplate = strArray.join('');
    },
    validate() {
      this.$refs.form.validate();
    },
    async Get(id) {
      let self = this;
      self.dialog = true;
      self.loading = true;
      await self.$call.GetGPTModelById(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            await self.Edit(dataResponse.data);
            await self.changePlatform(self.LLmsModel.platform, { preserveModel: true });
            await self.changeModel(self.LLmsModel.model);
            self.disabledConfig();
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async GetAllDDModelManagement() {
      const id = this.$route.query.id ?? this.LLmsModel.modelId;
      let self = this;
      self.dialog = true;
      await self.$call.GetAllDDModelManagement(
        id,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data.vectorDBName;
            self.listDataIntegration = dataResponse.data.dataIntegration;
            self.DDGroupReplace = dataResponse.data.groupReplace;
            self.DDProductGroup = dataResponse.data.productGroup;
            self.DDProductGroup = dataResponse.data.productGroup;
            self.DDPromptTemplate = dataResponse.data.promptTemplate.listData;
            self.listDDProvider = dataResponse.data.provider;
            // self.listDDProvider.push({ providerName: "Other", id: 0 });
            self.listDDModel = dataResponse.data.modelData;
            self.listDDIntentGroup = dataResponse.data.intentGroup;
            self.DDGroupPromptTemplate = dataResponse.data.groupPromptTemplate;
            self.listMonitorLineName = dataResponse.data.monitorSocialLine;
            self.flowDropdown = dataResponse.data.flowDropdown;
            if (self.modelID) {
              // self.modelID = self.$route.query.id;
              self.listSqlExtract = dataResponse.data.modelPublih.filter((e) => e.idEncrypt != self.modelID && e.typeName == 'Bot');
            } else {
              self.listSqlExtract = dataResponse.data.modelPublih.filter((e) => e.typeName == 'Bot');
            }
            self.listGuardRailModel = dataResponse.data.modelPublih.filter((e) => e.typeName == 'GuardRail');
          } else {
            self.DDVector = [];
            self.listDataIntegration = [];
            self.listSqlExtract = [];
            self.listGuardRailModel = [];
            self.DDGroupReplace = [];
            self.DDProductGroup = [];
            self.DDPromptTemplate = [];
            self.listDDProvider = [];
            self.listDDModel = [];
          }
          self.dialog = false;
          if (self.modelID != null) {
            await self.Get(self.modelID);
          }

          if (self.page.includes('Playground')) {
            this.localEditAction = self.page.includes('Edit');
            await self.changePlatform(self.LLmsModel.platform, { preserveModel: true });
            await self.changeModel(self.LLmsModel.model);
          } else if (self.page == 'view model') {
            this.localEditAction = false;
          } else {
            this.localEditAction = false;
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
    Save(actions) {
      let self = this;
      if (self.validateMaxToken()) {
        return;
      }
      if (self.txtToImgChecker && self.LLmsModel.styleImage == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please select style image and response format image',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (self.LLmsModel.enableTime == true && (self.LLmsModel.timeZone == null || self.LLmsModel.timeZone == '')) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningEnableTime'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (self.LLmsModel.typeLLM == undefined) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTypeLLM'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
  

      const selectedModelForSave = self.findModelDefinition(self.LLmsModel.model, self.DDModelShow) || self.findModelDefinition(self.LLmsModel.model);

      let modelData = {
        modelId: self.LLmsModel.modelId,
        modelName: self.LLmsModel.modelName,
        provider: self.LLmsModel.provider,
        model: self.normalizeModelValue(selectedModelForSave?.modelName || self.LLmsModel.model),
        modelNameDisplay: selectedModelForSave?.modelDisplay || self.getModelValueParts(self.LLmsModel.model).display || null,
        APIVersion: self.getApiVersionForSave(),
        extension: self.LLmsModel.extension,
        description: self.LLmsModel.description,
        promptTemplate: self.LLmsModel.promptTemplate,
        gender: self.LLmsModel.gender,
        vectordbName: self.LLmsModel.vectordbName == null ? [] : self.LLmsModel.vectordbName,
        groupReplaceID: self.LLmsModel.groupReplaceID == null ? [] : self.LLmsModel.groupReplaceID,
        productGroupID: self.LLmsModel.productGroupID == null ? [] : self.LLmsModel.productGroupID,
        topVDB: self.LLmsModel.topVDB !== '' ? self.LLmsModel.topVDB : null,
        productTopVDB: self.LLmsModel.productTopVDB !== '' ? self.LLmsModel.productTopVDB : null,
        productCosine: self.LLmsModel.productCosine !== '' ? self.LLmsModel.productTopVDB : null,
        internet: self.LLmsModel.internet,
        feedback: self.LLmsModel.feedback,
        historyCount: self.LLmsModel.historyCount,
        historyMinute: self.LLmsModel.historyMinute > 0 ? -self.LLmsModel.historyMinute : self.LLmsModel.historyMinute,
        temperature: self.LLmsModel.temperature !== '' ? self.LLmsModel.temperature : null,
        topP: self.LLmsModel.topP !== '' ? self.LLmsModel.topP : null,
        frequencyPenalty: self.LLmsModel.frequencyPenalty !== '' ? self.LLmsModel.frequencyPenalty : null,
        presencePenalty: self.LLmsModel.presencePenalty !== '' ? self.LLmsModel.presencePenalty : null,
        stop: self.LLmsModel.stop !== '' ? self.LLmsModel.stop : null,
        maxTokens: self.LLmsModel.maxTokens == null || self.LLmsModel.maxTokens == '' ? self.totalTokens : self.LLmsModel.maxTokens,
        isStream: self.LLmsModel.isStream,
        // isBypass : self.LLmsModel.IsBypass,
        isFeedback: self.LLmsModel.isFeedback,
        isAllowImage: self.LLmsModel.isAllowImage,
        fileUploadLimit: self.LLmsModel.fileUploadLimit == null ? self.LLmsModel.fileUploadLimit : parseInt(self.LLmsModel.fileUploadLimit),
        versioning: self.LLmsModel.versioning,
        isPublish: self.LLmsModel.isPublish,
        modelIDGroup: self.LLmsModel.modelIDGroup,
        modelDisplay: self.LLmsModel.modelDisplay,
        Len_ShortMemory: self.LLmsModel.Len_ShortMemory ?? 200,
        IsLongTerm_Memory: self.LLmsModel.provider == 'Google' ? false : (self.LLmsModel.IsLongTerm_Memory ?? false),
        IsChainMassage: self.LLmsModel.IsChainMassage ?? false,
        LenChainMassage: self.LLmsModel.LenChainMassage,
        TimeSecondChainMassage: self.LLmsModel.TimeSecondChainMassage,
        Cosine: self.LLmsModel.Cosine,
        DataIntegrationID: self.LLmsModel.DataIntegrationID,
        SqlModelID: self.LLmsModel.SqlModelID,
        promptSqlNoData: self.LLmsModel.promptSqlNoData,
        IntentGroupID: self.LLmsModel.IntentGroupID,
        typingSpeed: parseInt(self.LLmsModel.typingSpeed),
        maximumChatInput: self.LLmsModel.maximumChatInput == null ? 200000 : parseInt(self.LLmsModel.maximumChatInput),
        loadingBarFlag: self.LLmsModel.loadingBarFlag,
        loadingBarDuration: self.LLmsModel.loadingBarDuration,
        forbiddenWord: self.forbiddenWordSaveHandle(self.LLmsModel.forbiddenWord),
        monitorLineUserID: self.LLmsModel.monitorLineUserID,
        isShowNameUserMonitor: self.LLmsModel.isShowNameUserMonitor,
        monitorSocialID: self.LLmsModel.monitorSocialID,
        styleImage: self.txtToImgChecker ? self.LLmsModel.styleImage : null,
        resFormatImage: self.txtToImgChecker ? self.LLmsModel.resFormatImage : null,
        modelType: self.LLmsModel.modelType,
        quality: self.txtToImgChecker ? self.LLmsModel.quality : null,
        resolution: self.txtToImgChecker ? self.LLmsModel.resolution : null,
        JsonRequest: self.LLmsModel.jsonRequest,
        typeLLM: self.LLmsModel.typeLLM == 1 ? 'GuardRail' : 'Bot',
        guardRailModelID: self.LLmsModel.typeLLM == 0 ? self.LLmsModel.guardRailModelID : null,
        timeZone: self.LLmsModel.enableTime ? self.LLmsModel.timeZone : null,
        reasoningEffort: self.showReasoningEffort ? (self.LLmsModel.reasoningEffort || 'low') : null,
        endPointURL: self.LLmsModel.endPointURL != '' && self.LLmsModel.endPointURL != null ? self.LLmsModel.endPointURL : null,
        apI_Key: self.LLmsModel.apI_Key != '' && self.LLmsModel.apI_Key != null ? self.LLmsModel.apI_Key : null,
        authenHeaderName: self.LLmsModel.authenHeaderName != '' && self.LLmsModel.authenHeaderName != null ? self.LLmsModel.authenHeaderName : null,
        platform: self.LLmsModel.platform != '' && self.LLmsModel.platform != null ? self.LLmsModel.platform : null,
        isAllowLLMChange: self.LLmsModel.isAllowLLMChange,
        flowGroupID: self.LLmsModel.flowGroupID,
        CategoryID: self.LLmsModel.categoryName ? (self.findExistingCategory(self.LLmsModel.categoryName)?.id ?? null) : null,
      };

      if (self.LLmsModel.modelName == null || self.LLmsModel.modelName == '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningModelName'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.platform) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please select platform',
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.provider) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningProvider'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (!self.LLmsModel.model) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningModel'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.isPublish == null) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningPublish'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      }
      if (this.LLmsModel.IsChainMassage == true) {
        if (this.LLmsModel.LenChainMassage == null || this.LLmsModel.LenChainMassage == '' || this.LLmsModel.TimeSecondChainMassage == null || this.LLmsModel.TimeSecondChainMassage == '') {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningChainMassage'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
      } else if (self.LLmsModel.temperature == null || self.LLmsModel.temperature < 0 || self.LLmsModel.temperature > 1 || self.LLmsModel.temperature === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTemperature'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.topP == null || self.LLmsModel.topP < 0 || self.LLmsModel.topP > 1 || self.LLmsModel.topP === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopP'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.maximumChatInput == null || self.LLmsModel.maximumChatInput < 0 || self.LLmsModel.maximumChatInput === '') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningmaximumChatInput'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.topVDB == null && self.LLmsModel.vectordbName.length > 0) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.LLmsModel.productTopVDB == null && self.LLmsModel.productGroupID.length > 0) {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: self.$t('warningTopVDB'),
          showConfirmButton: false,
          timer: 3000,
        });
        return;
      } else if (self.isApiVersionMissing()) {
        if (self.page.includes('Playground')) {
          if (actions !== 'playground-confirmed') {
            self.$swal.fire({
              icon: 'warning',
              title: self.$t('warning'),
              text: self.$t('warningAPIVersion'),
              confirmButtonText: 'OK',
              cancelButtonText: self.$t('close'),
              showCancelButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                self.Save('playground-confirmed');
              }
            });
            return;
          }
        } else {
          self.$swal.fire({
            icon: 'warning',
            title: self.$t('warning'),
            text: self.$t('warningAPIVersion'),
            showConfirmButton: false,
            timer: 3000,
          });
          return;
        }
      }
      if (typeof self.validatePrompt(self.LLmsModel.promptTemplate) == 'string') {
        self.$swal.fire({
          icon: 'warning',
          title: self.$t('warning'),
          text: 'Please Enter Correct Format!',
          showConfirmButton: false,
          timer: 1800,
        });
        return;
      }
      self.dialog = true;
      try {
        self.saveLoading = true;
        self.LLmsModel.frequencyPenalty = self.LLmsModel.frequencyPenalty != '' ? self.LLmsModel.frequencyPenalty : null;
        self.LLmsModel.presencePenalty = self.LLmsModel.presencePenalty != '' ? self.LLmsModel.presencePenalty : null;
        self.LLmsModel.topVDB = self.LLmsModel.topVDB != '' ? self.LLmsModel.topVDB : null;
        self.LLmsModel.productTopVDB = self.LLmsModel.productTopVDB != '' ? self.LLmsModel.productTopVDB : null;
        self.LLmsModel.IsLongTerm_Memory = self.LLmsModel.provider == 'Google' ? false : (self.LLmsModel.IsLongTerm_Memory ?? false);
        self.LLmsModel.typingSpeed = parseInt(self.LLmsModel.typingSpeed);
        self.LLmsModel.maximumChatInput = parseInt(self.LLmsModel.maximumChatInput);
        // let cloneLLmsModel = Object.assign({}, self.LLmsModel);
        // cloneLLmsModel.forbiddenWord = self.forbiddenWordSaveHandle(self.LLmsModel.forbiddenWord)
        self.$call.AddGPTModel(
          modelData,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let msgSuccess = self.page == 'Edit Model' || self.localEditAction ? '✔ Successfully Updated !' : '✔ Successfully Created !';
              self.$swal.fire({
                title: msgSuccess,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: {
                  popup: 'success-banner',
                  title: 'success-banner-title',
                },
                backdrop: false, // **สำคัญ ถ้าไม่ต้องการบัง UI**
              });

              if (self.page.includes('Playground')) {
                self.$emit('is-event', {
                  type: 'PlaygroundSaved',
                  id: dataResponse.data,
                  side: self.LLmsModel.side,
                });
              } else if (actions == 's&c') self.$router.push('/GPTModelManagement');
              else {
                self.$router
                  .push({
                    name: 'GPTModelDetail',
                    query: {
                      id: dataResponse.data,
                    },
                  })
                  .then(() => {
                    self.Get(dataResponse.data);
                  });
              }
            }
            if (dataResponse.status == 1 && dataResponse.data.is_exist) {
              self.$swal.fire({
                icon: 'error',
                title: 'Model ID is exist',
                showConfirmButton: false,
                timer: 1800,
              });
            }
            self.saveLoading = false;
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            self.Adddialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    async Edit(item) {
      let self = this;
      if (self.page !== 'Model Creator') {
        self.localEditAction = true;
      } else {
        self.localEditAction = null;
      }
      self.GPTModel_isPublish = item.isPublish;
      self.LLmsModel.modelId = item.modelID;
      self.LLmsModel.modelName = item.modelName;
      self.LLmsModel.provider = item.provider;
      self.LLmsModel.model = self.buildModelSelectionValue(item.model, item.modelNameDisplay);
      self.LLmsModel.APIVersion = item.apiVersion;
      self.LLmsModel.extension = item.extension;
      self.LLmsModel.description = item.description;
      self.LLmsModel.promptTemplate = item.promptTemplate;
      self.LLmsModel.gender = item.gender;
      self.LLmsModel.vectordbName = item.vectordbName;
      self.LLmsModel.groupReplaceID = item.groupReplaceID;
      self.LLmsModel.productGroupID = item.productGroupID ?? [];
      self.LLmsModel.topVDB = item.topVDB;
      self.LLmsModel.productTopVDB = item.productTopVDB;
      self.LLmsModel.productCosine = item.productCosine;
      self.LLmsModel.internet = item.internet;
      self.LLmsModel.feedback = item.feedback;
      self.LLmsModel.historyCount = item.historyCount;
      self.LLmsModel.historyMinute = item.historyMinute < 0 ? Math.abs(item.historyMinute) : item.historyMinute;
      self.LLmsModel.temperature = item.temperature;
      self.LLmsModel.topP = item.top_p;
      self.LLmsModel.frequencyPenalty = item.frequency_penalty;
      self.LLmsModel.presencePenalty = item.presence_penalty;
      self.LLmsModel.stop = item.stop;
      self.LLmsModel.maxTokens = item.max_tokens;
      self.LLmsModel.isStream = item.isStream;
      self.LLmsModel.isBypass = item.isBypass;
      self.LLmsModel.isFeedback = item.isFeedback;
      self.LLmsModel.isAllowImage = item.isAllowImage;
      self.LLmsModel.fileUploadLimit = item.fileUploadLimit == null ? item.fileUploadLimit : parseInt(item.fileUploadLimit);
      self.LLmsModel.versioning = item.versioning;
      self.LLmsModel.isPublish = self.page == 'view model' ? (item.isPublish == null ? false : item.isPublish) : item.isPublish;
      self.LLmsModel.modelIDGroup = item.modelIDGroup;
      self.LLmsModel.modelDisplay = item.modelDisplay;
      self.LLmsModel.Len_ShortMemory = item.len_ShortMemory ?? 200;
      self.LLmsModel.IsLongTerm_Memory = self.LLmsModel.provider == 'Google' ? false : (item.isLongTerm_Memory ?? false);
      self.LLmsModel.IsChainMassage = item.isChainMassage ?? false;
      self.LLmsModel.LenChainMassage = item.lenChainMassage;
      self.LLmsModel.TimeSecondChainMassage = item.timeSecondChainMassage;
      self.LLmsModel.Cosine = item.cosine;
      self.LLmsModel.DataIntegrationID = item.dataIntegrationID;
      self.LLmsModel.SqlModelID = item.sqlModelID;
      self.LLmsModel.promptSqlNoData = item.promptSqlNoData;
      self.LLmsModel.IntentGroupID = item.intentGroupID;
      self.LLmsModel.typingSpeed = parseInt(item.typingSpeed);
      self.LLmsModel.maximumChatInput = item.maximumChatInput == null ? 200000 : parseInt(item.maximumChatInput);
      self.LLmsModel.loadingBarFlag = item.loadingBarFlag;
      self.LLmsModel.loadingBarDuration = item.loadingBarDuration;
      self.LLmsModel.forbiddenWord = self.forbiddenWordHandle(item.forbiddenWord) ?? [''];
      self.LLmsModel.monitorLineUserID = item.monitorLineUserID;
      self.LLmsModel.isShowNameUserMonitor = item.isShowNameUserMonitor;
      self.LLmsModel.monitorSocialID = item.monitorSocialID;
      self.LLmsModel.typeLLM = item.typeLLM == 'GuardRail' ? 1 : 0;
      self.LLmsModel.guardRailModelID = item.guardRailModelID;
      self.LLmsModel.modelType = item.modelType;
      self.LLmsModel.styleImage = item.styleImage;
      self.LLmsModel.resFormatImage = item.resFormatImage;
      self.LLmsModel.quality = item.quality;
      self.LLmsModel.resolution = item.resolution;
      self.LLmsModel.jsonRequest = item.jsonRequest;
      self.LLmsModel.enableTime = item.timeZone ? true : false;
      self.LLmsModel.timeZone = item.timeZone;
      self.LLmsModel.reasoningEffort = item.reasoningEffort;
      self.LLmsModel.endPointURL = item.endPointURL;
      self.LLmsModel.apI_Key = item.apI_Key;
      self.LLmsModel.authenHeaderName = item.authenHeaderName;
      self.LLmsModel.platform = item.platform;
      self.EditdialogUser = true;
      self.LLmsModel.isAllowLLMChange = item.isAllowLLMChange;
      self.LLmsModel.flowGroupID = item.flowGroupID;
      self.LLmsModel.categoryName = item.categoryID ? (self.categories.find(c => c.id === item.categoryID)?.name ?? null) : null;
      // let templistDDVector = self.DDVector.map((item) => item.name);
      // self.LLmsModel.vectordbName = self.LLmsModel.vectordbName.filter((item) =>
      //   templistDDVector.includes(item)
      // );
    },
    savePlayground() {
      this.$emit('is-event', 'SaveEdit');
      return true;
    },
    closePlayground() {
      let self = this;
      self.$emit('is-event', 'Close');
    },
    checkValidate() {
      if (this.LLmsModel.vectordbName != null && this.LLmsModel.vectordbName != '') {
        if (this.LLmsModel.topVDB == '' || this.LLmsModel.topVDB == null) {
          return 'Required.';
        } else if (parseInt(this.LLmsModel.topVDB) == 0) {
          return 'Required.';
        }
      }
      if (this.LLmsModel.IsChainMassage == true) {
        if (this.LLmsModel.LenChainMassage == null || this.LLmsModel.LenChainMassage == '' || this.LLmsModel.TimeSecondChainMassage == null || this.LLmsModel.TimeSecondChainMassage == '') {
          return 'Required.';
        }
      }
      return true;
    },
    checkProductValidate() {
      if (this.LLmsModel.productGroupID != null && this.LLmsModel.productGroupID != '') {
        if (this.LLmsModel.productTopVDB == '' || this.LLmsModel.productTopVDB == null) {
          return 'Required.';
        } else if (parseInt(this.LLmsModel.productTopVDB) == 0) {
          return 'Required.';
        }
      }
      return true;
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46 && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    maxNumberpositive: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;

      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionStart);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > 6 || // Check if the length exceeds 6 characters
        parseInt(newValue) > 200000
      ) {
        // Check if the number exceeds 200000
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateNumber: function (evt) {
      evt = evt || window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;

      let inputValue = evt.target.value.toString();
      let selectionStart = evt.target.selectionStart;
      let selectionEnd = evt.target.selectionEnd;
      let newValue;
      if (selectionStart !== selectionEnd) {
        // If there is a text selection, we need to replace the selected text
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionEnd);
      } else {
        // Otherwise, we are inserting the new character at the cursor position
        newValue = inputValue.substring(0, selectionStart) + evt.key + inputValue.substring(selectionStart);
      }

      if (
        charCode < 48 ||
        charCode > 57 || // Check if the key is not a number
        newValue.length > 5 || // Check if the length exceeds 4 characters
        parseInt(newValue) > 20000 // Check if the number exceeds 2048
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validatePrompt(inputValue) {
      if (!inputValue) {
        return true;
      }
      if (this.maxLengthChar == null) {
        return true;
      } else {
        return inputValue.length <= this.maxLengthChar || 'กรุณากรอกข้อมูลตัวอักษรไม่เกิน ' + this.convertNumberToStringFormat(this.maxLengthChar);
      }
    },
    validateInput0_1(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return 'Required.';
      return (value >= 0 && value <= 1 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 1 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateInput0_2(inputValue) {
      // ตรวจสอบว่าข้อมูลที่ป้อนเข้ามาเป็นตัวเลขที่อยู่ระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำ๝หน่ง
      const value = parseFloat(inputValue);
      if (isNaN(value)) return true;
      return (value >= 0 && value <= 2 && this.isTwoDecimalPlaces(value)) || 'กรุณาป้อนตัวเลขระหว่าง 0 ถึง 2 ที่มีทศนิยม 2 ตำแหน่ง';
    },
    validateMaxToken() {
      this.error.maxTokens.error = false;
      this.error.maxTokens.message = '';
      if (this.LLmsModel.maxTokens > this.totalTokens && this.totalTokens != null) {
        this.error.maxTokens.error = true;
        this.error.maxTokens.message = 'Max tokens cannot exceed the total tokens limit ' + this.totalTokens;
        this.$swal.fire({
          icon: 'warning',
          title: this.$t('warning'),
          text: this.error.maxTokens.message,
          showConfirmButton: false,
          timer: 3000,
          backdrop: false,
        });
        return true;
      }
      return false;
    },
    isTwoDecimalPlaces(number) {
      const regex = /^\d+(\.\d{1,2})?$/;
      return regex.test(number.toString());
    },
    convertNumberToStringFormat(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    normalizeModelValue(value) {
      if (typeof value !== 'string') {
        return value;
      }

      const trimmedValue = value.trim();
      if (!trimmedValue.includes('|')) {
        return trimmedValue;
      }

      const parts = trimmedValue.split('|');
      const model = (parts.shift() || '').trim();
      const modelNameDisplay = parts.join('|').trim();

      if (!modelNameDisplay || model === modelNameDisplay) {
        return model;
      }

      return `${model}|${modelNameDisplay}`;
    },
    customFilter(fn, listData) {
      const f = [];
      for (let i = 0; i < listData.length; i++) {
        if (fn(listData[i])) {
          f.push(listData[i]);
        }
      }
      return f;
    },
    async changePlatform(value, options = {}) {
      const preserveModel = options.preserveModel === true;
      const fixedProvider = this.getFixedProviderByPlatform(value);

      if (!value) {
        this.LLmsModel.provider = null;
        this.DDModelShow = [];
        this.resetModelSelection();
        return 'Required.';
      }

      if (fixedProvider) {
        this.LLmsModel.provider = fixedProvider;
        await this.changeProvider(fixedProvider, { preserveModel });
        return true;
      }

      const hasCurrentProvider = this.availableProviders.some((provider) => provider.providerName === this.LLmsModel.provider);
      if (!hasCurrentProvider) {
        this.LLmsModel.provider = null;
        this.DDModelShow = [];
        this.resetModelSelection();
        return true;
      }

      await this.changeProvider(this.LLmsModel.provider, { preserveModel });
      return true;
    },
    async changeProvider(value, options = {}) {
      let self = this;
      const preserveModel = options.preserveModel === true;

      if (!self.LLmsModel.platform) {
        self.LLmsModel.provider = null;
        self.DDModelShow = [];
        self.resetModelSelection();
        return 'Please select platform first.';
      }

      if (value == null || value == '') {
        self.DDModelShow = [];
        self.resetModelSelection();
        return 'Required.';
      }

      self.DDModelShow = self.getModelsForSelection(value, self.LLmsModel.platform);

      const hasCurrentModel = Boolean(self.findModelDefinition(self.LLmsModel.model, self.DDModelShow));
      if (!preserveModel || !hasCurrentModel) {
        self.resetModelSelection();
      }

      return true;
    },
    clearLLM() {
      this.resetModelSelection();
    },
    async changeModel(value) {
      let self = this;

      if (!Array.isArray(self.listDDModel) || self.listDDModel.length === 0) {
        return true;
      }

      const selectedModel = self.findModelDefinition(value, self.modelSelectionOptions);
      if (selectedModel && !selectedModel.useUploadFile) {
        self.LLmsModel.isAllowImage = false;
      }

      if (value == null || value == '' || value.split('')[0] == '|') {
        self.resetModelSelection();
        self.LLmsModel.platform = null;
        self.LLmsModel.provider = null;
        return 'required.';
      } else {
        let ddm = selectedModel || self.findModelDefinition(value);
        if (!ddm) {
          self.resetModelSelection();
          return true;
        }

        self.LLmsModel.model = ddm.modelName;

        self.totalTokens = ddm.maxToken;
        self.txtToImgChecker = ddm.modelType == 'text_to_image';
        const selectedModelName = self.getModelValueParts(ddm.modelName).model;
        if (selectedModelName == 'gpt-35-turbo') {
          self.maxLengthChar = 4000;
        } else if (selectedModelName == 'gpt-35-turbo-16k') {
          self.maxLengthChar = 8000;
        } else {
          self.maxLengthChar = selectedModelName == 'gpt-4' ? 6000 : null;
        }

        if (this.txtToImgChecker) {
          self.LLmsModel.quality = ddm.quality;
          self.LLmsModel.resolution = ddm.resolution;
          self.LLmsModel.resFormatImage = ddm.resFormatImage;
        } else {
          self.LLmsModel.styleImage = null;
          self.LLmsModel.resFormatImage = null;
          self.LLmsModel.quality = null;
          self.LLmsModel.resolution = null;
        }

        self.LLmsModel.APIVersion = self.requiresApiVersion(ddm.platform, ddm.provider) ? ddm.apiVersion : null;
        self.LLmsModel.modelType = ddm.modelType;
        self.LLmsModel.jsonRequest = ddm.jsonRequest;
        self.showReasoningEffort = ddm.useReasoningEffort === true;
        if (!self.showReasoningEffort) {
          self.LLmsModel.reasoningEffort = null;
        } else if (!self.LLmsModel.reasoningEffort) {
          self.LLmsModel.reasoningEffort = 'low';
        }
        self.LLmsModel.endPointURL = ddm.endPointURL;
        self.LLmsModel.apI_Key = ddm.apI_Key;
        self.LLmsModel.authenHeaderName = ddm.authenHeaderName;
        self.LLmsModel.platform = ddm.platform || null;
        self.LLmsModel.provider = ddm.provider || null;

        if (ddm.useUploadFile) {
          self.showFileUpload = ddm.useUploadFile;
        } else {
          self.showFileUpload = false;
          self.LLmsModel.isAllowImage = false;
          self.LLmsModel.fileUploadLimit = null;
        }
      }
    },
    numericKey: function (evt) {
      evt = evt ? evt : window.event;
      let expect = evt.target.value.toString() + evt.key.toString();
      if (!/^\d*\.?\d*$/.test(expect) || parseFloat(expect) <= 0) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    showPromptTemplate() {
      let self = this;
      if (self.DDGroupPromptTemplate.length > 0) {
        self.showPromptTem = !self.showPromptTem;
      } else {
        self.showPromptTem = false;
      }
    },
    showAll() {
      let self = this;
      self.dialogShowAll = true;
    },
    forbiddenWordHandle(forbiddenWord) {
      if (!forbiddenWord) {
        return this.LLmsModel.forbiddenWord && this.LLmsModel.forbiddenWord.length ? this.LLmsModel.forbiddenWord : [''];
      }

      try {
        const parsedData = JSON.parse(forbiddenWord);
        return Array.isArray(parsedData) && parsedData.length ? parsedData : [''];
      } catch (error) {
        console.error('Failed to parse forbidden words', error);
        return [''];
      }
    },
    forbiddenWordSaveHandle(inputList) {
      if (!Array.isArray(inputList)) {
        return null;
      }

      const sanitizedList = inputList.map((element) => (element ?? '').trim()).filter((element) => element !== '');

      if (sanitizedList.length === 0) {
        return null;
      }

      return JSON.stringify(sanitizedList);
    },
    selectCategoryFromHeader(categoryName) {
      this.LLmsModel.categoryName = categoryName || null;
      this.categoryMenuOpen = false;
    },
    openAddCategoryDialog() {
      this.newCategoryName = '';
      this.dialog_addCategory = true;
      this.categoryMenuOpen = false;
      this.closeRenameCategoryDialog();
    },
    closeCategoryDialog() {
      this.dialog_addCategory = false;
      this.newCategoryName = '';
    },
    openRenameCategoryDialog(category) {
      this.renameCategoryTarget = category;
      this.renameCategoryName = category.name;
      this.dialog_renameCategory = true;
    },
    closeRenameCategoryDialog() {
      this.dialog_renameCategory = false;
      this.renameCategoryName = '';
      this.renameCategoryTarget = null;
    },
    SaveCategory() {
      let self = this;
      const name = self.normalizeCategoryDisplayName(self.newCategoryName);
      if (!name) {
        self.$swal.fire({ icon: 'warning', title: 'Category name is required', showConfirmButton: true, confirmButtonText: 'OK', confirmButtonColor: '#FFA726' });
        return;
      }
      const existingCategory = self.findExistingCategory(name);
      if (existingCategory) {
        self.LLmsModel.categoryName = existingCategory.name;
        self.$swal({ icon: 'warning', title: 'Duplicate', text: `"${name}" already exists.`, timer: 2000, showConfirmButton: false });
        return;
      }
      try {
        if (typeof self.$call.AddGPTModelCategory === 'function') {
          self.$call.AddGPTModelCategory(
            { name },
            (res) => {
              if (res && res.status == 0) {
                const addedCategory = self.normalizeCategoryOption(res.data || { name });
                self.categories = self.dedupeCategories([...(self.categories || []), addedCategory]);
                self.LLmsModel.categoryName = (addedCategory && addedCategory.name) || name;
                self.reloadCategories(self.LLmsModel.categoryName);
                self.closeCategoryDialog();
                self.$swal.fire({
                  title: `✔ Category "${name}" created successfully!`,
                  showConfirmButton: false,
                  timer: 1500,
                  position: 'top',
                  background: 'transparent',
                  customClass: { popup: 'success-banner', title: 'success-banner-title' },
                });
                return;
              }

              self.$swal({
                icon: 'warning',
                title: 'Duplicate',
                text: res?.message || `"${name}" already exists.`,
                timer: 2200,
                showConfirmButton: false,
              });
            },
            () => {
              self.$swal({
                icon: 'error',
                title: 'Unable to create category',
                text: 'Please try again.',
                timer: 2200,
                showConfirmButton: false,
              });
            }
          );
        } else {
          self.categories = self.dedupeCategories([...(self.categories || []), { name }]);
          self.LLmsModel.categoryName = name;
          self.closeCategoryDialog();
        }
      } catch (e) {
        self.$swal({
          icon: 'error',
          title: 'Unable to create category',
          text: 'Please try again.',
          timer: 2200,
          showConfirmButton: false,
        });
      }
    },
    RenameCategory() {
      let self = this;
      if (!self.renameCategoryTarget?.id) {
        return;
      }

      const name = self.normalizeCategoryDisplayName(self.renameCategoryName);
      if (!name) {
        self.$swal.fire({ icon: 'warning', title: 'Category name is required', showConfirmButton: true, confirmButtonText: 'OK', confirmButtonColor: '#FFA726' });
        return;
      }

      const duplicateCategory = self.findCategoryByName(name, self.renameCategoryTarget.id);
      if (duplicateCategory) {
        self.$swal.fire({ icon: 'warning', title: 'Duplicate', text: `"${name}" already exists.`, timer: 2000, showConfirmButton: false });
        return;
      }

      self.$call.UpdateGPTModelCategory(
        { id: self.renameCategoryTarget.id, name },
        (res) => {
          if (res && res.status == 0) {
            self.categories = self.dedupeCategories((self.categories || []).map((category) => (
              category.id === self.renameCategoryTarget.id ? { ...category, name } : category
            )));
            if (self.normalizeCategoryName(self.LLmsModel.categoryName) === self.normalizeCategoryName(self.renameCategoryTarget.name)) {
              self.LLmsModel.categoryName = name;
            }
            self.reloadCategories(self.LLmsModel.categoryName);
            self.closeRenameCategoryDialog();
            self.$swal.fire({
              title: `✔ Category "${name}" renamed successfully!`,
              showConfirmButton: false,
              timer: 1500,
              position: 'top',
              background: 'transparent',
              customClass: { popup: 'success-banner', title: 'success-banner-title' },
            });
            return;
          }

          self.$swal({ icon: 'warning', title: res?.message || 'Duplicate category name', showConfirmButton: true, confirmButtonText: 'OK', confirmButtonColor: '#FFA726' });
        },
        () => {
          self.$swal({ icon: 'error', title: 'Unable to rename category', text: 'Please try again.', timer: 2200, showConfirmButton: false });
        }
      );
    },
    deleteCategory(category) {
      let self = this;
      self.$swal.fire({
        icon: 'warning',
        title: `Delete category "${category.name}"?`,
        text: 'Models using this category will be cleared.',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#d33',
      }).then((result) => {
        if (!result.isConfirmed) {
          return;
        }

        self.$call.DeleteGPTModelCategory(
          category.id,
          (res) => {
            if (res && res.status == 0) {
              self.categories = self.dedupeCategories((self.categories || []).filter((item) => item.id !== category.id));
              if (self.normalizeCategoryName(self.LLmsModel.categoryName) === self.normalizeCategoryName(category.name)) {
                self.LLmsModel.categoryName = null;
              }
              self.reloadCategories(self.LLmsModel.categoryName);
              if (self.renameCategoryTarget?.id === category.id) {
                self.closeRenameCategoryDialog();
              }
              self.$swal.fire({
                title: `✔ Category "${category.name}" deleted successfully!`,
                showConfirmButton: false,
                timer: 1500,
                position: 'top',
                background: 'transparent',
                customClass: { popup: 'success-banner', title: 'success-banner-title' },
              });
              return;
            }

            self.$swal({ icon: 'warning', title: res?.message || 'Unable to delete category', showConfirmButton: true, confirmButtonText: 'OK', confirmButtonColor: '#FFA726' });
          },
          () => {
            self.$swal({ icon: 'error', title: 'Unable to delete category', text: 'Please try again.', timer: 2200, showConfirmButton: false });
          }
        );
      });
    },
  },
  async mounted() {
    let self = this;
    await self.GetAllDDModelManagement();
    if (!this.LLmsModel.reasoningEffort && this.reasonOptions.length > 0) {
      this.LLmsModel.reasoningEffort = this.reasonOptions[0].value;
    }
    // Load categories safely (backend may not have this API yet)
    try {
      if (typeof self.$call.GetGPTModelCategory === 'function') {
        self.$call.GetGPTModelCategory(
          (res) => {
            if (res && res.status == 0) {
              self.categories = self.dedupeCategories(res.data || []);
              self.syncSelectedCategoryName();
            }
          },
          () => { self.categories = []; }
        );
      }
    } catch (e) { self.categories = []; }
  },
};
</script>
<style scoped>
.category-manager-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  margin-bottom: 12px;
}

.category-manager-label {
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
}

.category-manager-list {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid rgba(25, 118, 210, 0.12);
  border-radius: 12px;
  background: #fafcff;
}

.category-manager-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.category-manager-item:last-child {
  border-bottom: none;
}

.category-manager-name {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #1f2937;
  font-size: 13px;
}

.category-manager-name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-manager-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.category-manager-empty {
  min-height: 96px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #90a4ae;
  font-size: 13px;
}

/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #ffffff !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #ffffff !important;
  border: 1px solid #c32e0e !important;
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #c32e0e !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}
hr {
  border: none;
  border-top: 1px solid #c9c9c9;
}
.select-prompt {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  background: #ffffff !important;
}
.select-prompt :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.select-prompt :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.select-prompt :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.knowledge-card {
  border: 1px solid #c9c9c9 !important;
  border-radius: 10px !important;
  padding: 12px;
  margin-left: 4px;
}
.circle-button-no-data {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #c1c3cb !important;
  padding: 8px !important;
  border-radius: 16px !important;
  gap: 4px !important;
  width: 80px;
  height: 32px !important;
  margin-left: 40px !important;
}
.workflow-panel-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px !important;
  border-radius: 10px;
  background: linear-gradient(100deg, #fff2f2 0%, #ffded8 100%) !important;
}
.workflow-right {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* v-switch */
.memory-switch :deep(.v-switch__track) {
  background: #a6a6a6 !important; /* off state */
  border: 1px solid #ffffff !important;
  opacity: 1 !important;
  height: 20px !important;
  width: 32px !important;
  border-radius: 22px !important;
}
.memory-switch :deep(.v-switch__thumb) {
  box-shadow: none !important;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px !important;
  background-color: #ffffff !important;
}
/* Active (on) state */
.memory-switch :deep(.v-selection-control--dirty .v-switch__track) {
  background-color: #ffffff !important;
  border: 1px solid #c32e0e !important;
}
.memory-switch :deep(.v-selection-control--dirty .v-switch__thumb) {
  background-color: #c32e0e !important;
  margin-right: 8px !important;
}
.memory-switch :deep(.v-switch__loader) {
  display: none !important;
}
.add-example-section {
  display: flex;
  align-items: center;
  justify-content: center !important;
  border: 1px solid #c32e0e;
  border-radius: 10px;
  gap: 6px;
  padding: 10px;
  width: 100px;
  height: 42px !important;
}
.add-example-section:hover {
  background: rgba(195, 0, 0, 0.1);
}
.footer-btn {
  border-radius: 10px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}
.footer-btn.save {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  background: #04b439 !important;
  width: 100px;
  height: 42px !important;
}
.footer-btn.save:hover {
  background: rgba(4, 180, 57, 0.75) !important;
}
.footer-btn.save span {
  font-size: 16px;
  color: #ffffff;
}
.label-style {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
}

.card2 {
  border: 1px solid #c9c9c9 !important;
  border-radius: 10px !important;
  padding: 20px 10px !important;
}

textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.icon {
  order: 0;
}

.header {
  font-weight: 700;
}

.model-header-title-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.publication-header-controls {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.publication-header-wrapper {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.model-id-chip {
  margin-left: 12px;
  min-width: 110px;
  max-width: 100%;
  min-height: 20px;
  padding: 10px 16px;
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important;  
  box-shadow: none !important;
}

.model-id-chip__text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.publication-status-chip {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  width: 100px;
  height: 32px;
  box-shadow: none !important;
}

.publication-label {
  font-size: 14px;
  font-weight: 600;
  color: #171717;
}

.publication-toggle {
  margin: 0 4px;
}

.publication-toggle :deep(.v-switch__track) {
  transform: scale(0.8);
  width: 40px;
  height: 28px;
  border-radius: 999px;
  border: 2px solid transparent;
  background-color: transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.publication-toggle :deep(.v-switch__thumb) {
  width: 20px;
  height: 20px;
  box-shadow: none;
  border: 2px solid transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease;
}

.publication-toggle--active :deep(.v-switch__track) {
  background-color: #ffffff !important;
  border-color: #d32f2f;
}

.publication-toggle--active :deep(.v-switch__thumb) {
  background-color: #d32f2f !important;
  border-color: #d32f2f;
  transform: translateX(-0.5px);
}

.publication-toggle--inactive :deep(.v-switch__track) {
  background-color: #bdbdbd !important;
  border-color: #bdbdbd;
}

.publication-toggle--inactive :deep(.v-switch__thumb) {
  background-color: #ffffff !important;
  border-color: #bdbdbd;
  width: 30px;
  height: 30px;
}

.publication-version {
  font-size: 14px;
  font-weight: 600;
  color: #c32e0e;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.v-text-field :deep(label) {
  font-size: 0.9375rem;
}
:deep(.v-text-field .v-input__details) {
  padding-inline: 7px 3px !important;
}

.v-expansion-panel-header {
  padding: 0;
  background-color: transparent !important;
}

:deep(.expan-Pannel) .v-expansion-panel--active > .v-expansion-panel-header {
  min-height: 48px;
  background-color: transparent !important;
}

.forbidden-btn {
  opacity: 0;
}

.forbidden-btn:hover {
  opacity: 100%;
}

.deep-purple.accent-4 {
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
}

.image-settings-container {
  border-radius: 4px;
  padding: 16px;
}

.info-icon {
  position: absolute;
  right: -6px;
  top: 0;
}

.image-select {
  width: auto;
}

.info-icon:hover {
  color: #1976d2;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
}

.v-col {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
}

.v-card {
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none;
}

.v-tab {
  text-transform: none;
  font-weight: 500;
}

.v-text-field.v-text-field--enclosed .v-text-field__details,
.v-select.v-select--enclosed .v-select__details {
  margin-bottom: 0;
}

.model-type-toggle {
  width: 100% !important;
  border-radius: 12px;
  gap: 8px;
}

.model-type-btn {
  flex: 1;
  height: 36px !important;
  text-transform: none;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
  min-width: 120px !important;
  border-radius: 12px !important;
}

.model-type-card {
  border-radius: 12px;
  border: none !important;
  transition: background 1s ease;
}

.model-input-group {
  align-items: center;
}

.model-input-col {
  display: flex;
  flex-direction: column;
}
.model-input-control :deep(.v-field__append-inner .v-icon) {
  color: #872612 !important;
}
.model-input-control :deep(.v-list .v-list-item--active .v-list-item-title) {
  color: #872612 !important;
  font-weight: 700;
}
.model-input-control :deep(.v-list .v-list-item:hover .v-list-item-title) {
  color: #872612 !important;
}
.model-input-control :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 44px !important;
  box-shadow: none !important;
  background: #ffffff !important;
}

.model-input-control :deep(.v-input__details) {
  display: none;
}

.model-input-control :deep(.v-field__input) {
  padding-top: 10px;
}

.custom-vertical-divider {
  width: 1px;
  border-radius: 999px;
  background: #00000039;
  min-height: 60px;
}

@media (max-width: 960px) {
  .vertical-divider-wrapper {
    display: none !important;
  }
}

.model-input-control :deep(.v-field__outline) {
  border-radius: 12px;
  --v-field-border-opacity: 0.4;
}

.model-input-control :deep(.v-field__outline--focused) {
  --v-field-border-opacity: 1;
}

@media (max-width: 960px) {
  .model-input-row {
    gap: 12px;
  }

  .model-input-control :deep(.v-field) {
    min-height: 44px !important;
  }
}

/* Bot button styles */
.v-btn-toggle .v-btn--active {
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important;
  box-shadow: none !important;
  border: none !important;
  color: white !important;
}

/* Make expansion panel background transparent */
:deep(.v-expansion-panels) {
  background-color: transparent !important;
}

/* Make individual expansion panel background transparent */
:deep(.v-expansion-panel) {
  background-color: transparent !important;
}

/* Make expansion panel content background transparent */
:deep(.v-expansion-panel-content) {
  background-color: transparent !important;
}

/* Make expansion panel header background transparent */
:deep(.v-expansion-panel-header) {
  background-color: transparent !important;
}

/* Optional: Remove box-shadow if present */
:deep(.v-expansion-panels) {
  box-shadow: none !important;
}

:deep(.v-expansion-panel)::before {
  box-shadow: none !important;
}

.model-chip {
  padding: 0 50px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: none;
  transition: all 0.5s ease;
}

.model-chip:hover {
  opacity: 1;
}

.model-id {
  color: black;
  margin-left: 4px;
  font-weight: 500;
}

/* Optional: Add a subtle animation when the chip appears */
.model-chip {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.position-relative {
  position: relative;
}

.version-badge {
  z-index: 1;
}

.version-text {
  margin-left: -4px;
  font-size: 11px;
  font-weight: 500;
  color: #616161;
  letter-spacing: 0.4px;
}

.modern-panels {
  background: transparent;
  border-radius: 20px;
  padding: 12px;
}

.modern-panels :deep(.v-expansion-panel) {
  background-color: #ffffff !important;
  border-radius: 16px !important;
  margin-bottom: 16px;
  overflow: hidden;
  transition:
    border-color 0.25s ease,
    box-shadow 0.25s ease,
    transform 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel:not(:last-of-type)) {
  margin-bottom: 18px;
}

.modern-panels :deep(.v-expansion-panel--active) {
  border: 1px solid #e5e7eb;
  transform: translateY(-2px);
}

.modern-panels :deep(.v-expansion-panel-title) {
  min-height: auto;
  padding: 18px 24px;
  background: linear-gradient(135deg, #fff2f2 0%, #ffded8 100%);
  transition:
    background-color 0.2s ease,
    padding 0.2s ease;
}

.modern-panels :deep(.v-expansion-panel-title--active) {
  background: transparent;
}

.modern-panels :deep(.v-expansion-panel-text) {
  background: #ffffff;
  padding: 20px 24px 24px;
}

.modern-panels :deep(.v-expansion-panel-title__overlay) {
  background-color: transparent !important;
}

.modern-panels :deep(.v-expansion-panel-title__icon) {
  margin-left: auto;
  color: #9ca3af;
  transition:
    transform 0.25s ease,
    color 0.25s ease;
}

.modern-panels :deep(.v-expansion-panel-title--active .v-expansion-panel-title__icon) {
  color: #ef4444;
  transform: rotate(180deg);
}

.panel-header {
  width: 100%;
  column-gap: 12px;
  color: #1f2937;
}

.panel-header .header {
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.workflow-header {
  justify-content: flex-start;
  column-gap: 16px;
  row-gap: 4px;
}

.workflow-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
}

.workflow-header__text {
  display: flex;
  flex-direction: column;
}

.workflow-header__text .header {
  font-size: 17px;
}

.workflow-header__subtitle {
  font-size: 13px;
  color: #646464;
}

.workflow-header__title {
  color: #1f2937;
}

@media (max-width: 600px) {
  .workflow-header {
    align-items: flex-start;
  }

  .workflow-header__icon {
    width: 40px;
    height: 40px;
  }

  .workflow-header__subtitle {
    font-size: 12px;
  }
}

.panel-content {
  padding: 22px 0;
  background: linear-gradient(180deg, rgba(249, 250, 251, 0.4) 0%, rgba(255, 255, 255, 0.95) 40%, rgba(255, 255, 255, 1) 100%);
  border-top: 1px solid #e5e7eb;
}

/* อนิเมชัน */
.transition-swing {
  transition-duration: 0.3s;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.prompt-template-container {
  padding: 0.5rem 0;
}

.prompt-editor-card {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 8px;
  transition: all 0.2s ease;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5);
  box-shadow: 0 1px 3px rgba(227, 6, 6, 0.05);
}

.prompt-textarea {
  font-family: 'Roboto Mono', monospace;
  line-height: 1.5;
  border: none !important;
  box-shadow: none !important;
  padding: 4px !important;
  font-size: 14px;
  min-height: 300px !important;
  margin-top: -32px !important;
}

.prompt-editor-card {
  border: 1px solid #c9c9c9 !important;
  margin-top: 12px;
  box-shadow: none !important;
  transition: all 0.2s ease;
  overflow: hidden;
}

.prompt-editor-card:hover {
  border-color: rgba(25, 118, 210, 0.5) !important;
}

.prompt-templates-card {
  border-radius: 8px;
  background-color: #fff2f2;
  transition: all 0.3s ease;
}

.template-list-item {
  border-radius: 4px;
  margin-bottom: 2px;
  transition: all 0.2s ease;
}

.template-list-item:hover {
  background-color: rgba(25, 118, 210, 0.04);
}

.prompt-template-list {
  max-height: 500px;
  overflow-y: auto;
  background-color: transparent;
}

.template-list-all {
  max-height: 400px;
  overflow-y: auto;
}

.v-divider {
  border-color: rgba(0, 0, 0, 0.753) !important;
}

.v-card {
  transition: all 0.2s ease;
}

.rounded-lg {
  border-radius: 8px !important;
}

.v-card__title {
  font-size: 1rem !important;
  padding: 12px 16px !important;
}

.v-card__text {
  padding: 12px 16px !important;
}

.h-100 {
  height: 100%;
}

/* Fix position of tooltips */
:deep(.v-tooltip__content) {
  background-color: rgba(33, 33, 33, 0.95);
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 5px 10px;
}

.options-section {
  padding: 16px 20px;
}

.option-card {
  padding: 5px 16px;
  border-radius: 10px !important;
  background-color: #ededed;
  height: 50px !important;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);
  position: relative;
  overflow: hidden;
}

.on-hover {
  border-color: rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.08) !important;
}

.option-header {
  max-width: calc(100% - 70px);
}
/* Card title styling */
.v-card__title.subtitle-1 {
  font-size: 16px !important;
  padding: 14px 20px !important;
  background-color: transparent;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}

.additional-content {
  min-height: 44px;
}

.upload-limit-field,
.timezone-field {
  min-height: 58px;
}

.status-switch-container {
  border-radius: 8px;
  background-color: #f5f5f5;
  transition: all 0.3s ease;
}

.status-switch {
  transform: scale(1.2);
}

.status-label {
  min-width: 150px;
}

.status-container {
  background-color: #f9f9f9;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-toggle {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.toggle-btn {
  text-transform: none;
  letter-spacing: 0.5px;
  min-width: 90px;
}

.active-btn.draft-btn {
  background-color: rgba(255, 152, 0, 0.1) !important;
  color: #ff9800 !important;
  font-weight: 500;
}

.active-btn.publish-btn {
  background-color: rgba(76, 175, 80, 0.1) !important;
  color: #4caf50 !important;
  font-weight: 500;
}

.enhanced-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
}

.enhanced-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
}

.enhanced-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
}

/* Selection Display */
.timezone-selection {
  width: 100%;
  padding: 2px 0;
}

.timezone-code {
  font-size: 10px !important;
  height: 18px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Dropdown Items */
.timezone-item {
  padding: 12px 16px !important;
  border-radius: 6px;
  margin: 2px 8px;
  transition: all 0.2s ease;
}

.timezone-item:hover {
  background-color: rgba(25, 118, 210, 0.04) !important;
  transform: translateX(2px);
}

.timezone-item-content {
  width: 100%;
}

.timezone-country {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.2;
}

.timezone-details {
  gap: 8px;
}

/* Avatar styling */
.timezone-item :deep(.v-avatar) {
  margin-right: 12px;
}

/* Dropdown styling */
.enhanced-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.enhanced-select :deep(.v-list) {
  padding: 8px 0 !important;
  background-color: white;
}

/* Icon animations */
.timezone-item :deep(.v-icon) {
  transition: all 0.2s ease;
}

.timezone-item:hover :deep(.v-icon) {
  transform: scale(1.1);
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .timezone-selection {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .timezone-code {
    margin-left: 0 !important;
    margin-top: 4px !important;
  }
}

.reasoning-chip {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center !important;
  min-width: 120px;
  height: 28px !important;
}

.reasoning-chip :deep(.v-chip__content) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  text-align: center !important;
  font-weight: 500;
}

.reasoning-chip :deep(.v-chip__underlay) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* สำหรับ Vuetify 3 */
.reasoning-chip :deep(.v-chip__content) {
  padding: 0 8px !important;
  line-height: 2 !important;
}

/* Image Generation Settings Styling */
.image-settings-card {
  border: 1px solid #c9c9c9 !important;
  border-radius: 16px !important;
  overflow: hidden;
}

.setting-group {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
  height: 100%;
}

.setting-group:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.3);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.setting-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
  margin-bottom: 8px;
}

/* Enhanced Select Styling */
.style-select :deep(.v-field) {
  border-radius: 8px !important;
  transition: all 0.2s ease;
  background: white;
}

.style-select :deep(.v-field:hover) {
  box-shadow: 0 2px 8px rgba(25, 118, 210, 0.15);
  border-color: rgba(11, 133, 255, 0.829) !important;
}

.style-select :deep(.v-field--focused) {
  box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.2);
  border-color: rgba(25, 118, 210, 0.8) !important;
}

/* Style Items */
.style-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
}

.style-item:hover {
  background: linear-gradient(135deg, rgba(220, 237, 255, 0.767) 0%, rgba(138, 197, 255, 0.568) 100%);
  transform: translateX(3px);
}

/* Quality and Resolution Fields */
.quality-field :deep(.v-field),
.resolution-field :deep(.v-field) {
  border-radius: 8px !important;
  background: rgba(245, 245, 245, 0.8) !important;
  /* transition: all 0.2s ease; */
}

.quality-field :deep(.v-field:hover),
.resolution-field :deep(.v-field:hover) {
  background: rgba(240, 240, 240, 0.9) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

/* Animation Improvements */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-20px) scale(0.95);
}

/* Responsive Design */
@media (max-width: 960px) {
  .setting-group {
    margin-bottom: 16px;
  }

  .image-header {
    padding: 16px !important;
  }

  .image-header h3 {
    font-size: 1.1rem !important;
  }
}

/* Dropdown Enhancements */
.style-select :deep(.v-overlay__content) {
  border-radius: 12px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.style-select :deep(.v-list) {
  padding: 8px !important;
  background: rgba(255, 255, 255, 0.95);
}

/* Chip Enhancements */
.v-chip.v-chip--size-x-small {
  font-size: 10px !important;
  height: 20px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

.v-chip.v-chip--size-small {
  font-size: 11px !important;
  height: 24px !important;
  font-weight: 500;
  letter-spacing: 0.5px;
}

/* Loading State */
.image-settings-container.loading {
  opacity: 0.7;
  pointer-events: none;
}

.image-settings-container.loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 1;
}

.status-wrapper {
  padding: 20px;
}

.status-header {
  margin-bottom: 4px;
}

.status-display-section {
  padding: 8px 0;
}

.status-badge-container {
  margin-bottom: 8px;
}

.status-description {
  display: flex;
  align-items: center;
  opacity: 0.8;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}

.status-switch {
  transform: scale(1.1);
}

.switch-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-alert {
  border-radius: 12px !important;
  border: none !important;
  padding: 12px 16px !important;
}

.alert-content {
  line-height: 1.3;
}

/* Switch Styling */
.status-switch :deep(.v-switch__track) {
  width: 48px !important;
  height: 24px !important;
  border-radius: 12px !important;
}

.status-switch :deep(.v-switch__thumb) {
  width: 20px !important;
  height: 20px !important;
  border-radius: 10px !important;
}

/* Avatar animations */
.status-wrapper .v-avatar {
  transition: all 0.3s ease;
}

/* แบบเต็มหน้าจอ */
.publication-status-card-full {
  border-radius: 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
}

.status-wrapper-full {
  padding: 24px;
}

.status-wrapper-full .v-icon {
  transition: all 0.2s ease;
}

.status-header-full {
  margin-bottom: 8px;
}

.status-chip-large {
  font-weight: 600 !important;
  font-size: 14px !important;
  padding: 0 20px !important;
  height: 40px !important;
  border-radius: 20px !important;
  display: flex;
  justify-content: center;
  min-width: 150px;
}

.status-content-section {
  margin: 0 -8px;
}

.status-info-card,
.status-control-card {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  padding: 16px;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.status-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.model-stats .stat-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.stat-label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
}

.stat-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.toggle-container {
  display: flex;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(89, 150, 211, 0.03) 0%, rgba(53, 134, 216, 0.08) 100%);
}

.status-switch-large {
  transform: scale(1.3);
}

.status-switch-active :deep(.v-switch__track) {
  background-color: rgba(76, 175, 79, 0.4) !important;
}

.status-switch-active :deep(.v-switch__thumb) {
  background-color: #4caf50 !important;
  box-shadow: 0px 0px 4px rgba(47, 177, 7, 0.705);
}

.status-switch-inactive :deep(.v-switch__track) {
  box-shadow: 2px 3px 6px rgba(90, 60, 45, 0.582);
  background-color: rgba(255, 153, 0, 0.3) !important;
  border: 1px solid rgba(253, 140, 11, 0.15) !important;
}

.status-switch-inactive :deep(.v-switch__thumb) {
  background-color: #ff9800 !important;
}

.switch-label-container {
  text-align: center;
  min-width: 100px;
  display: flex;
  flex-direction: column;
}

.switch-label-large {
  font-size: 16px;
  font-weight: 600;
  display: block;
  transition: color 0.3s ease;
}

.status-control-card .switch-label-large {
  color: rgba(0, 0, 0, 0.87);
}

.switch-sublabel {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  display: block;
  margin-top: 4px;
}

.publish-card {
  background: linear-gradient(135deg, rgba(var(--v-theme-primary), 0.03) 0%, rgba(var(--v-theme-secondary), 0.01) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.publish-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(var(--v-theme-primary), 0.05), transparent);
  transition: left 0.6s ease;
}
.no-data-message-card {
  padding: 18px 22px;
  border-radius: 16px !important;
  background: linear-gradient(180deg, #ffffff 0%, #fff6f4 100%);
  border: 1px solid rgba(195, 46, 14, 0.2) !important;
  box-shadow: 0 4px 15px rgba(195, 46, 14, 0.08);
}
.no-data-message-content {
  max-width: calc(100% - 140px);
}
.no-data-message-title {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #c32e0e;
  margin-bottom: 6px;
}
.no-data-message-preview {
  font-size: 13px;
  color: rgba(55, 65, 81, 0.85);
  line-height: 1.5;
  max-height: 60px;
  overflow: hidden;
}
.no-data-message-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c32e0e !important;
  border-radius: 12px !important;
  width: 200px;
  height: 48px !important;
  padding: 8px !important;
  gap: 8px;
}
.no-data-dialog-card {
  border-radius: 18px !important;
  overflow: hidden;
  background: linear-gradient(180deg, #ffffff 0%, #fff8f6 100%);
}
.no-data-dialog-card :deep(.v-card-title) {
  font-weight: 600;
  letter-spacing: 0.3px;
}
.no-data-dialog-card :deep(.v-card-text .v-field) {
  border-radius: 12px !important;
}
.no-data-dialog-card :deep(.v-card-actions) {
  gap: 8px;
}

.memory-section-wrapper {
  margin-bottom: 0px;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.memory-card {
  border-radius: 18px !important;
  background: #fff2f2;
  height: 160px;
}

.memory-card__body {
  display: flex;
  column-gap: 24px;
  row-gap: 18px;
  align-items: stretch;
}

.memory-card__short,
.memory-card__long {
  display: flex;
  flex-direction: column;
}

.memory-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.memory-section-header.justify-space-between {
  align-items: center;
}

.memory-icon {
  display: flex;
  align-items: center !important;
  justify-content: start;
  gap: 8px;
}

.memory-title {
  font-size: 16px;
  font-weight: 600;
  color: #171717;
  margin-bottom: 4px;
}

.memory-subtitle {
  font-size: 12px;
  color: rgba(55, 65, 81, 0.65);
}

.memory-status {
  font-size: 13px;
  color: rgba(55, 65, 81, 0.75);
}

.memory-card :deep(.v-field) {
  border-radius: 12px !important;
  background-color: #ffffff !important;
  border: 1px solid rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 4px 10px rgba(195, 46, 14, 0.05);
}

.memory-card :deep(.v-field:hover) {
  box-shadow: 0 6px 14px rgba(195, 46, 14, 0.08);
}

.memory-card__divider {
  align-self: stretch;
  margin: 0 8px;
  height: 100%;
  border: 1px solid rgba(229, 231, 235, 0.8);
}

.memory-input-row {
  margin-top: -15px;
  padding-left: 10px;
}

.col-label-input {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
}

.multi-turn-section {
  margin-top: 18px;
  border-radius: 16px;
  padding: 18px 0px;
}

.multi-turn-toggle {
  display: flex;
  align-items: center !important;
  justify-content: start;
  gap: 8px;
}

.multi-turn-label {
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
  font-size: 14px;
}

.forbidden-container {
  border-radius: 16px;
  padding: 18px;
  background: #ffffff;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  row-gap: 14px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.forbidden-summary {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.forbidden-summary__info {
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.forbidden-summary__title {
  font-weight: 600;
  font-size: 14px;
  color: #111827;
  margin: 0;
}

.forbidden-summary__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: rgba(55, 65, 81, 0.7);
}

.forbidden-summary__count {
  font-size: 13px;
  color: rgba(17, 24, 39, 0.75);
  background: rgba(195, 46, 14, 0.08);
  border-radius: 999px;
  padding: 6px 14px;
  font-weight: 600;
  align-self: center;
}

.forbidden-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(55, 65, 81, 0.65);
  font-size: 13px;
  background: rgba(248, 250, 252, 0.85);
  border-radius: 12px;
  padding: 12px;
  border: 1px dashed rgba(148, 163, 184, 0.6);
}

.forbidden-list {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.forbidden-item {
  display: flex;
  align-items: center;
  column-gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid rgba(229, 231, 235, 0.8);
}

.forbidden-item:last-child {
  border-bottom: none;
}

.forbidden-index {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(195, 46, 14, 0.12);
  font-weight: 600;
  color: #c32e0e;
}

.forbidden-input {
  flex: 1;
}

.forbidden-input :deep(.v-field) {
  border-radius: 10px !important;
  background: rgba(248, 250, 252, 0.8) !important;
}

.forbidden-input :deep(.v-field:hover) {
  box-shadow: inset 0 0 0 1px rgba(195, 46, 14, 0.25);
}

.forbidden-delete {
  min-width: 36px !important;
  width: 36px !important;
  height: 36px !important;
  border-radius: 12px !important;
}

.forbidden-footer {
  padding-top: 12px;
  display: flex;
  justify-content: flex-start;
}

.forbidden-add-btn {
  display: flex;
  align-items: center;
  justify-content: center !important;
  gap: 8px;
  padding: 8px;
}
.forbidden-add-btn:hover {
  border-radius: 12px;
  background: #fde4df;
}

.forbidden-fade-enter-active,
.forbidden-fade-leave-active {
  transition: all 0.18s ease;
}

.forbidden-fade-enter-from,
.forbidden-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.multi-turn-section :deep(.v-field) {
  border-radius: 12px !important;
}

@media (max-width: 960px) {
  .memory-card__body {
    flex-direction: column;
  }

  .memory-card__divider {
    display: none;
  }

  .forbidden-item {
    flex-direction: column;
    align-items: stretch;
    row-gap: 10px;
    padding: 14px 0;
  }

  .forbidden-index {
    width: 32px;
    height: 32px;
    align-self: flex-start;
  }

  .forbidden-summary {
    flex-direction: column;
    gap: 12px;
  }

  .forbidden-summary__count {
    align-self: flex-start;
  }
}

@media (max-width: 600px) {
  .memory-card {
    padding: 20px 18px;
  }

  .multi-turn-section {
    padding: 16px;
  }

  .forbidden-container {
    padding: 14px;
  }
}

.publish-card:hover::before {
  left: 100%;
}

/* Flow Selection Card Styling */
.flow-selection-card {
  border-radius: 16px !important;
  border: 1px solid rgba(25, 118, 210, 0.12) !important;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 1) 100%);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.flow-selection-card:hover {
  border-color: rgba(25, 118, 210, 0.3) !important;
  box-shadow: 0 8px 24px rgba(25, 118, 210, 0.08) !important;
}

.flow-card-header {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.03) 0%, rgba(25, 118, 210, 0.08) 100%);
  border-bottom: 1px solid rgba(25, 118, 210, 0.1);
}

.flow-selector-wrapper {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.flow-selector-wrapper:hover {
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

/* Enhanced Flow Select */
.flow-select-enhanced :deep(.v-field) {
  border-radius: 12px !important;
  transition: all 0.3s ease;
  background: white;
  height: 48px;
}

.autocomplete-field-c :deep(.v-field__field) {
  padding-top: 3px;
}

/* Flow Selection Display */
.flow-selection-display {
  padding: 4px 0;
  width: 100%;
}

/* Flow Dropdown Items */
.flow-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.2s ease;
  padding: 12px 16px !important;
}

.flow-list-item:hover {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.04) 0%, rgba(25, 118, 210, 0.08) 100%);
  transform: translateX(4px);
}

/* Flow Status Display */
.flow-status-display {
  position: relative;
  padding: 16px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  height: 100%;
}

.flow-status-display:hover {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(25, 118, 210, 0.2);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.flow-status-content {
  padding: 8px 0;
}

.flow-connected,
.flow-disconnected {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

/* Enhanced Info Button */
.info-btn-enhanced {
  position: relative;
  transition: all 0.2s ease;
}

.info-btn-enhanced:hover {
  background-color: rgba(25, 118, 210, 0.08) !important;
  transform: scale(1.1);
}

/* Dropdown Enhancements */
.flow-select-enhanced :deep(.v-overlay__content) {
  border-radius: 16px !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(25, 118, 210, 0.1);
  overflow: hidden;
}

.flow-select-enhanced :deep(.v-list) {
  padding: 12px !important;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
}

/* Chip Animations */
.flow-connected .v-chip,
.flow-disconnected .v-chip {
  animation: chipPulse 2s ease-in-out infinite;
}

@keyframes chipPulse {
  0%,
  100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.02);
  }
}

/* Responsive Design */
@media (max-width: 960px) {
  .flow-selector-wrapper,
  .flow-status-display {
    margin-bottom: 16px;
  }

  .flow-card-header {
    padding: 16px !important;
  }

  .flow-card-header .text-h6 {
    font-size: 1.1rem !important;
  }
}

/* Icon Animations */
.flow-selection-card .v-icon {
  transition: all 0.2s ease;
}

.flow-selection-card:hover .v-icon {
  transform: scale(1.05);
}

.model-type-toggle-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  height: 48px;
  border-radius: 14px;
  padding: 8px;
}

.description-field :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  min-height: 50px;
}

.description-field :deep(.v-field__input) {
  padding-top: 13px !important;
}

.rounded-input :deep(.v-field) {
  border-radius: 12px !important;
  min-height: 44px;
}
.input--enabled :deep(.v-field) {
  background-color: #ffffff !important;
}
.input--disabled :deep(.v-field) {
  background-color: #ffffff !important;
  color: rgba(55, 65, 81, 0.6) !important;
}
.input--disabled :deep(.v-field__input),
.input--disabled :deep(.v-select__selection-text),
.input--disabled :deep(input) {
  color: rgba(55, 65, 81, 0.6) !important;
}
.padding-input :deep(.v-field) {
  padding-top: 5px !important;
}
.padding-input2 :deep(.v-field) {
  padding-top: 4px !important;
}

.dialog-close-btn {
  border: 1px solid #c32e0e !important; /* red outline */
  color: #c32e0e !important;
  background: transparent !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  height: 40px !important;
  width: 100px !important;
  box-shadow: none !important;
}
.dialog-close-btn .v-icon {
  margin-right: 6px;
}
.dialog-save-btn {
  background: linear-gradient(90deg, #c32e0e 0%, #f67760 100%) !important; /* orange gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: none !important;
}
.dialog-save-btn-green {
  background: #04b439 !important; /* green gradient */
  color: #fff !important;
  border-radius: 12px !important;
  padding: 6px 18px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  height: 40px !important;
  width: 120px !important;
  box-shadow: none !important;
}
.dialog-save-btn .v-icon {
  margin-right: 6px;
}
.flow-not-selected {
  background: #c1c3cb !important;
  color: white !important;
}
.flow-selected {
  background: rgba(42, 191, 86, 0.1) !important;
  color: #04b439 !important;
}
.chipdiv {
  margin-right: 15px;
  gap: 10px;
}
.chipspan {
  color: #646464;
  font-family: var(--Poppins-Font, Poppins);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.image-icon-style {
  width: 24px;
  height: 24px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

.model-option-subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  color: #94a3b8;
  font-size: 12px;
  font-weight: 500;
}

.model-option-meta {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  max-width: 45%;
}

.model-option-meta-value {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.model-option-meta-separator {
  flex: 0 0 auto;
  color: #cbd5e1;
}

.model-selection-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-menu-trigger {
  margin-left: 8px;
  height: 32px !important;
  padding: 0 10px !important;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f8fafc;
  text-transform: none !important;
  letter-spacing: normal !important;
  min-width: 0 !important;
}

.category-menu-trigger :deep(.v-btn__content) {
  display: flex;
  align-items: center;
}

.category-menu-text {
  color: #1f2937;
  font-size: 12px;
  font-weight: 600;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-menu-text--placeholder {
  color: #94a3b8;
  font-weight: 500;
}

.category-menu-list {
  min-width: 220px;
}

.category-menu-new__title {
  color: #1976D2;
  font-weight: 600;
  font-size: 13px;
}

.category-menu-empty {
  color: #94a3b8;
  font-size: 12px;
  font-style: italic;
}

.model-provider-details {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.model-provider-pill {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  padding: 2px 8px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #f8fafc;
  line-height: 1.4;
}

.model-provider-label {
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  margin-right: 4px;
  white-space: nowrap;
}

.model-provider-value {
  color: #1f2937;
  font-size: 12px;
  font-weight: 600;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
